import { Line } from '../objects/line'
import { TextView } from '../objects/text';
import { Rectangle } from '../objects/rectangle';
import { Ellipse } from '../objects/ellipse';
import { Button } from '../objects/button';
import { ImageView } from '../objects/image';
import { GroupView } from '../objects/group';
import { Polygon } from '../objects/polygon';
import { Polyline } from '../objects/polyline';
import { Sector } from '../objects/sector';
import { Border } from '../objects/border';
import { Scale } from 'chart.js';
import { TextArea } from '../objects/textarea';
import { Sphere } from '../objects/sphere';
import { Cylinder } from '../objects/cylinder';
import { Cylinder3D } from '../objects/cylinder3d';
import { Cone } from '../objects/cone';
import { Sector3D } from '../objects/sector3d';
import { PolygonGradient } from '../objects/polygongradient';
import { Tank } from '../objects/tank';
import { Border3d } from '../objects/border3d';
import { Text3DView } from '../objects/text3d';
import { ValueWithHistory } from '../objects/valuewithhistory';
import { PressButton } from '../objects/pressbutton';
import { ToggleButton } from '../objects/togglebutton';
import { LightButton } from '../objects/lightbutton';
import { OvalLightButton } from '../objects/ovallightbutton';
import { ImageButton } from '../objects/imagebutton';
import { OvalJumpButton } from '../objects/ovaljumpbutton';
import { RectJumpButton } from '../objects/rectjumbbutton';
import { RightJumpButton } from '../objects/rightjumpbutton';
import { LeftJumpButton } from '../objects/leftjumpbutton';
import { Switch } from '../objects/switch';
import { Switch3Pos } from '../objects/switch3pos';
import { SwitchApple } from '../objects/switchapple';
import { OvalLamp } from '../objects/ovallamp';
import { RectangleLamp } from '../objects/rectanglelamp';
import { TriangleLamp } from '../objects/trianglelamp';
import { TriangleLamp2 } from '../objects/trianglelamp2';
import { StackLamp } from '../objects/stacklamp';
import { Indicator } from '../objects/indicator';
import { RectIndicator } from '../objects/rectindicator';
import { OvalIndicator } from '../objects/ovalindicator';
import { Slider } from '../objects/slider';
import { SliderVertical } from '../objects/slidervertical';
import { SliderHorizontal } from '../objects/sliderhorizontal';
import { SliderApple } from '../objects/sliderapple';
import { Counter } from '../objects/counter';
import { CounterRect } from '../objects/counterrect';
import { Selector } from '../objects/selector';
import { Combobox } from '../objects/combobox';
import { Menubox } from '../objects/menubox';
import { Checkbox } from '../objects/checkbox';
import { MenuCheckList } from '../objects/menuchecklist';
import { CheckList } from '../objects/checklist';
import { ParameterList } from '../objects/parameterlist';
import { StraightPipe } from '../objects/straightpipe';
import { StraightPipe2 } from '../objects/straightpipe2';
import { EndPipe } from '../objects/endpipe';
import { EndPipe2 } from '../objects/endpipe2';
import { BowPipe } from '../objects/bowpipe';
import { BowPipe2 } from '../objects/bowpipe2';
import { TeePipe } from '../objects/teepipe';
import { TeePipe2 } from '../objects/teepipe2';
import { IntersectPipe } from '../objects/intersectpipe';
import { IntersectPipe2 } from '../objects/intersectpipe2';
import { ElbowPipe } from '../objects/elbowpipe';
import { ElbowPipe2 } from '../objects/elbowpipe2';
import { PolyPipe } from '../objects/polypipe';
import { Valve } from '../objects/valve';
import { ValveRound } from '../objects/valveround';
import { ValveISA } from '../objects/valveisa';
import { ValveBall } from '../objects/valveball';
import { Motor } from '../objects/motor';
import { ValvePosition } from '../objects/valveposition';
import { Pump } from '../objects/pump';
import { AirBlowerPump } from '../objects/airblowerpump';
import { PumpStand } from '../objects/pumpstand';
import { Fan } from '../objects/fan';
import { CentrifugalPump } from '../objects/centrifugalpump';
import { FanRound } from '../objects/fanround';
import { FanSquare } from '../objects/fansquare';
import { FanCool } from '../objects/fancool';
import { FanBlades } from '../objects/fanblades';
import { FanCentrifugal } from '../objects/fancentrifugal';
import { FanAxial } from '../objects/fanaxial';
import { VerticalTank } from '../objects/verticaltank';
import { HorizontalTank } from '../objects/horizontaltank';
import { ConeTank } from '../objects/conetank';
import { VerticalTankWithTrend } from '../objects/verticaltankwithtrend';
import { HorizontalTankWithTrend } from '../objects/horizontaltankwithtrend';
import { ScrewConveyer } from '../objects/screwconveyer';
import { ScrewConveyerMotion } from '../objects/screwconveyermotion';
import { BeltConveyer } from '../objects/beltconveyer';
import { Auger } from '../objects/auger';
import { AnalogMeter } from '../objects/analogmeter';
import { AnalogMeterRect } from '../objects/analogmeterrect';
import { AnalogMeter90DegreesRect } from '../objects/analogmeter90degree';
import { AnalogMeter90DegreesRect2 } from '../objects/analogmeter90degree2';
import { AnalogMeterRound } from '../objects/analogmeterround';
import { AnalogMeterVertical } from '../objects/analogmetervert';
import { AnalogMeterVerticalFill } from '../objects/analogmetervertfill';
import { AnalogMeterHorizontal } from '../objects/analogmeterhor';
import { AnalogMeterHorizontalFill } from '../objects/analogmeterhorfill';
import { RangeIndicator } from '../objects/rangeindicator';
import { Gauge } from '../objects/gauge';
import { Gauge180 } from '../objects/gauge180';
import { Gauge90 } from '../objects/gauge90';
import { Gauge90_2 } from '../objects/gauge90_2';
import { DigitalMeter } from '../objects/digitalmeter';
import { Digital4DigitMeter } from '../objects/digital4digitmeter';
import { Digital6DigitMeter } from '../objects/digital6digitmeter';
import { Digital8DigitMeter } from '../objects/digital8digitmeter';
import { DigitalMeterHistoryAndEvent } from '../objects/digitalmeterhistoryandevent';
import { ElectricalSwitch } from '../objects/electricalswitch';
import { ElectricalSwitch2Way } from '../objects/electricalswitch2way';
import { ElectricalSwitchWithNeutral } from '../objects/electricalswitchwithneutral';
import { ElectricalTransformer } from '../objects/electricaltransformer';
import { AnalogClock } from '../objects/analogclock';
import { DigitalClock } from '../objects/digitalclock';
import { DateView } from '../objects/date';
import { Trend } from '../objects/trend';
import { EventsTable } from '../objects/eventstable';
import { PieChart } from '../objects/piechart';
import { EventsTicker } from '../objects/eventsticker';
import { Diagram } from '../objects/diagram';
import { ColorPicker } from '../objects/colorpicker';
import { ColorRectangle } from '../objects/colorrectangle';
import { DatabaseTable } from '../objects/databasetable';
import { DateChooser } from '../objects/datechooser';
import { EditView } from '../objects/editview';
import { Gauge2 } from '../objects/gauge2';
import { Gauge3 } from '../objects/gauge3';
import { HistoryTable } from '../objects/historydbtable';
import { RecipeSelector } from '../objects/recipeselector';
import { RecipeTable } from '../objects/recipetable';
import { SVGArchitecture1 } from '../objects/svg/architecture/svgarchitecture1';
import { SVGArchitecture10 } from '../objects/svg/architecture/svgarchitecture10';
import { SVGArchitecture11 } from '../objects/svg/architecture/svgarchitecture11';
import { SVGArchitecture12 } from '../objects/svg/architecture/svgarchitecture12';
import { SVGArchitecture13 } from '../objects/svg/architecture/svgarchitecture13';
import { SVGArchitecture14 } from '../objects/svg/architecture/svgarchitecture14';
import { SVGArchitecture15 } from '../objects/svg/architecture/svgarchitecture15';
import { SVGArchitecture16 } from '../objects/svg/architecture/svgarchitecture16';
import { SVGArchitecture17 } from '../objects/svg/architecture/svgarchitecture17';
import { SVGArchitecture18 } from '../objects/svg/architecture/svgarchitecture18';
import { SVGArchitecture19 } from '../objects/svg/architecture/svgarchitecture19';
import { SVGArchitecture2 } from '../objects/svg/architecture/svgarchitecture2';
import { SVGArchitecture20 } from '../objects/svg/architecture/svgarchitecture20';
import { SVGArchitecture21 } from '../objects/svg/architecture/svgarchitecture21';
import { SVGArchitecture3 } from '../objects/svg/architecture/svgarchitecture3';
import { SVGArchitecture4 } from '../objects/svg/architecture/svgarchitecture4';
import { SVGArchitecture5 } from '../objects/svg/architecture/svgarchitecture5';
import { SVGArchitecture6 } from '../objects/svg/architecture/svgarchitecture6';
import { SVGArchitecture7 } from '../objects/svg/architecture/svgarchitecture7';
import { SVGArchitecture8 } from '../objects/svg/architecture/svgarchitecture8';
import { SVGArchitecture9 } from '../objects/svg/architecture/svgarchitecture9';
import { SVGBlower1 } from '../objects/svg/blowers/svgblower1';
import { SVGBlower10 } from '../objects/svg/blowers/svgblower10';
import { SVGBlower11 } from '../objects/svg/blowers/svgblower11';
import { SVGBlower12 } from '../objects/svg/blowers/svgblower12';
import { SVGBlower13 } from '../objects/svg/blowers/svgblower13';
import { SVGBlower2 } from '../objects/svg/blowers/svgblower2';
import { SVGBlower3 } from '../objects/svg/blowers/svgblower3';
import { SVGBlower4 } from '../objects/svg/blowers/svgblower4';
import { SVGBlower5 } from '../objects/svg/blowers/svgblower5';
import { SVGBlower6 } from '../objects/svg/blowers/svgblower6';
import { SVGBlower7 } from '../objects/svg/blowers/svgblower7';
import { SVGBlower8 } from '../objects/svg/blowers/svgblower8';
import { SVGBlower9 } from '../objects/svg/blowers/svgblower9';
import { SVGBoiler1 } from '../objects/svg/boilers/svgboiler1';
import { SVGBoiler10 } from '../objects/svg/boilers/svgboiler10';
import { SVGBoiler11 } from '../objects/svg/boilers/svgboiler11';
import { SVGBoiler12 } from '../objects/svg/boilers/svgboiler12';
import { SVGBoiler2 } from '../objects/svg/boilers/svgboiler2';
import { SVGBoiler3 } from '../objects/svg/boilers/svgboiler3';
import { SVGBoiler4 } from '../objects/svg/boilers/svgboiler4';
import { SVGBoiler5 } from '../objects/svg/boilers/svgboiler5';
import { SVGBoiler6 } from '../objects/svg/boilers/svgboiler6';
import { SVGBoiler7 } from '../objects/svg/boilers/svgboiler7';
import { SVGBoiler8 } from '../objects/svg/boilers/svgboiler8';
import { SVGBoiler9 } from '../objects/svg/boilers/svgboiler9';
import { SVGButton1 } from '../objects/svg/buttons/svgbutton1';
import { SVGButton10 } from '../objects/svg/buttons/svgbutton10';
import { SVGButton11 } from '../objects/svg/buttons/svgbutton11';
import { SVGButton12 } from '../objects/svg/buttons/svgbutton12';
import { SVGButton13 } from '../objects/svg/buttons/svgbutton13';
import { SVGButton14 } from '../objects/svg/buttons/svgbutton14';
import { SVGButton15 } from '../objects/svg/buttons/svgbutton15';
import { SVGButton16 } from '../objects/svg/buttons/svgbutton16';
import { SVGButton17 } from '../objects/svg/buttons/svgbutton17';
import { SVGButton18 } from '../objects/svg/buttons/svgbutton18';
import { SVGButton19 } from '../objects/svg/buttons/svgbutton19';
import { SVGButton2 } from '../objects/svg/buttons/svgbutton2';
import { SVGButton3 } from '../objects/svg/buttons/svgbutton3';
import { SVGButton4 } from '../objects/svg/buttons/svgbutton4';
import { SVGButton5 } from '../objects/svg/buttons/svgbutton5';
import { SVGButton6 } from '../objects/svg/buttons/svgbutton6';
import { SVGButton7 } from '../objects/svg/buttons/svgbutton7';
import { SVGButton8 } from '../objects/svg/buttons/svgbutton8';
import { SVGButton9 } from '../objects/svg/buttons/svgbutton9';
import { SVGChemical1 } from '../objects/svg/chemical/svgchemical1';
import { SVGChemical10 } from '../objects/svg/chemical/svgchemical10';
import { SVGChemical11 } from '../objects/svg/chemical/svgchemical11';
import { SVGChemical12 } from '../objects/svg/chemical/svgchemical12';
import { SVGChemical13 } from '../objects/svg/chemical/svgchemical13';
import { SVGChemical14 } from '../objects/svg/chemical/svgchemical14';
import { SVGChemical15 } from '../objects/svg/chemical/svgchemical15';
import { SVGChemical2 } from '../objects/svg/chemical/svgchemical2';
import { SVGChemical3 } from '../objects/svg/chemical/svgchemical3';
import { SVGChemical4 } from '../objects/svg/chemical/svgchemical4';
import { SVGChemical5 } from '../objects/svg/chemical/svgchemical5';
import { SVGChemical6 } from '../objects/svg/chemical/svgchemical6';
import { SVGChemical7 } from '../objects/svg/chemical/svgchemical7';
import { SVGChemical8 } from '../objects/svg/chemical/svgchemical8';
import { SVGChemical9 } from '../objects/svg/chemical/svgchemical9';
import { SVGContainer1 } from '../objects/svg/containers/svgcontainer1';
import { SVGContainer10 } from '../objects/svg/containers/svgcontainer10';
import { SVGContainer11 } from '../objects/svg/containers/svgcontainer11';
import { SVGContainer2 } from '../objects/svg/containers/svgcontainer2';
import { SVGContainer3 } from '../objects/svg/containers/svgcontainer3';
import { SVGContainer4 } from '../objects/svg/containers/svgcontainer4';
import { SVGContainer5 } from '../objects/svg/containers/svgcontainer5';
import { SVGContainer6 } from '../objects/svg/containers/svgcontainer6';
import { SVGContainer7 } from '../objects/svg/containers/svgcontainer7';
import { SVGContainer8 } from '../objects/svg/containers/svgcontainer8';
import { SVGContainer9 } from '../objects/svg/containers/svgcontainer9';
import { SVGController1 } from '../objects/svg/controllers/svgcontroller1';
import { SVGController10 } from '../objects/svg/controllers/svgcontroller10';
import { SVGController11 } from '../objects/svg/controllers/svgcontroller11';
import { SVGController2 } from '../objects/svg/controllers/svgcontroller2';
import { SVGController3 } from '../objects/svg/controllers/svgcontroller3';
import { SVGController4 } from '../objects/svg/controllers/svgcontroller4';
import { SVGController5 } from '../objects/svg/controllers/svgcontroller5';
import { SVGController6 } from '../objects/svg/controllers/svgcontroller6';
import { SVGController7 } from '../objects/svg/controllers/svgcontroller7';
import { SVGController8 } from '../objects/svg/controllers/svgcontroller8';
import { SVGController9 } from '../objects/svg/controllers/svgcontroller9';
import { SVGConveyor1 } from '../objects/svg/conveyors/svgconveyor1';
import { SVGConveyor10 } from '../objects/svg/conveyors/svgconveyor10';
import { SVGConveyor11 } from '../objects/svg/conveyors/svgconveyor11';
import { SVGConveyor2 } from '../objects/svg/conveyors/svgconveyor2';
import { SVGConveyor3 } from '../objects/svg/conveyors/svgconveyor3';
import { SVGConveyor4 } from '../objects/svg/conveyors/svgconveyor4';
import { SVGConveyor5 } from '../objects/svg/conveyors/svgconveyor5';
import { SVGConveyor6 } from '../objects/svg/conveyors/svgconveyor6';
import { SVGConveyor7 } from '../objects/svg/conveyors/svgconveyor7';
import { SVGConveyor8 } from '../objects/svg/conveyors/svgconveyor8';
import { SVGConveyor9 } from '../objects/svg/conveyors/svgconveyor9';
import { SVGCooling1 } from '../objects/svg/cooling/svgcooling1';
import { SVGCooling10 } from '../objects/svg/cooling/svgcooling10';
import { SVGCooling11 } from '../objects/svg/cooling/svgcooling11';
import { SVGCooling2 } from '../objects/svg/cooling/svgcooling2';
import { SVGCooling3 } from '../objects/svg/cooling/svgcooling3';
import { SVGCooling4 } from '../objects/svg/cooling/svgcooling4';
import { SVGCooling5 } from '../objects/svg/cooling/svgcooling5';
import { SVGCooling6 } from '../objects/svg/cooling/svgcooling6';
import { SVGCooling7 } from '../objects/svg/cooling/svgcooling7';
import { SVGCooling8 } from '../objects/svg/cooling/svgcooling8';
import { SVGCooling9 } from '../objects/svg/cooling/svgcooling9';
import { SVGDuct1 } from '../objects/svg/duct/svgduct1';
import { SVGDuct10 } from '../objects/svg/duct/svgduct10';
import { SVGDuct11 } from '../objects/svg/duct/svgduct11';
import { SVGDuct12 } from '../objects/svg/duct/svgduct12';
import { SVGDuct13 } from '../objects/svg/duct/svgduct13';
import { SVGDuct14 } from '../objects/svg/duct/svgduct14';
import { SVGDuct15 } from '../objects/svg/duct/svgduct15';
import { SVGDuct16 } from '../objects/svg/duct/svgduct16';
import { SVGDuct17 } from '../objects/svg/duct/svgduct17';
import { SVGDuct18 } from '../objects/svg/duct/svgduct18';
import { SVGDuct19 } from '../objects/svg/duct/svgduct19';
import { SVGDuct2 } from '../objects/svg/duct/svgduct2';
import { SVGDuct20 } from '../objects/svg/duct/svgduct20';
import { SVGDuct21 } from '../objects/svg/duct/svgduct21';
import { SVGDuct22 } from '../objects/svg/duct/svgduct22';
import { SVGDuct23 } from '../objects/svg/duct/svgduct23';
import { SVGDuct24 } from '../objects/svg/duct/svgduct24';
import { SVGDuct25 } from '../objects/svg/duct/svgduct25';
import { SVGDuct3 } from '../objects/svg/duct/svgduct3';
import { SVGDuct4 } from '../objects/svg/duct/svgduct4';
import { SVGDuct5 } from '../objects/svg/duct/svgduct5';
import { SVGDuct6 } from '../objects/svg/duct/svgduct6';
import { SVGDuct7 } from '../objects/svg/duct/svgduct7';
import { SVGDuct8 } from '../objects/svg/duct/svgduct8';
import { SVGDuct9 } from '../objects/svg/duct/svgduct9';
import { SVGFactory1 } from '../objects/svg/factory/svgfactory1';
import { SVGFactory10 } from '../objects/svg/factory/svgfactory10';
import { SVGFactory11 } from '../objects/svg/factory/svgfactory11';
import { SVGFactory12 } from '../objects/svg/factory/svgfactory12';
import { SVGFactory13 } from '../objects/svg/factory/svgfactory13';
import { SVGFactory14 } from '../objects/svg/factory/svgfactory14';
import { SVGFactory15 } from '../objects/svg/factory/svgfactory15';
import { SVGFactory16 } from '../objects/svg/factory/svgfactory16';
import { SVGFactory17 } from '../objects/svg/factory/svgfactory17';
import { SVGFactory2 } from '../objects/svg/factory/svgfactory2';
import { SVGFactory3 } from '../objects/svg/factory/svgfactory3';
import { SVGFactory4 } from '../objects/svg/factory/svgfactory4';
import { SVGFactory5 } from '../objects/svg/factory/svgfactory5';
import { SVGFactory6 } from '../objects/svg/factory/svgfactory6';
import { SVGFactory7 } from '../objects/svg/factory/svgfactory7';
import { SVGFactory8 } from '../objects/svg/factory/svgfactory8';
import { SVGFactory9 } from '../objects/svg/factory/svgfactory9';
import { SVGFinish1 } from '../objects/svg/finish/svgfinish1';
import { SVGFinish10 } from '../objects/svg/finish/svgfinish10';
import { SVGFinish11 } from '../objects/svg/finish/svgfinish11';
import { SVGFinish12 } from '../objects/svg/finish/svgfinish12';
import { SVGFinish13 } from '../objects/svg/finish/svgfinish13';
import { SVGFinish14 } from '../objects/svg/finish/svgfinish14';
import { SVGFinish15 } from '../objects/svg/finish/svgfinish15';
import { SVGFinish16 } from '../objects/svg/finish/svgfinish16';
import { SVGFinish17 } from '../objects/svg/finish/svgfinish17';
import { SVGFinish18 } from '../objects/svg/finish/svgfinish18';
import { SVGFinish19 } from '../objects/svg/finish/svgfinish19';
import { SVGFinish2 } from '../objects/svg/finish/svgfinish2';
import { SVGFinish20 } from '../objects/svg/finish/svgfinish20';
import { SVGFinish21 } from '../objects/svg/finish/svgfinish21';
import { SVGFinish22 } from '../objects/svg/finish/svgfinish22';
import { SVGFinish23 } from '../objects/svg/finish/svgfinish23';
import { SVGFinish24 } from '../objects/svg/finish/svgfinish24';
import { SVGFinish25 } from '../objects/svg/finish/svgfinish25';
import { SVGFinish26 } from '../objects/svg/finish/svgfinish26';
import { SVGFinish27 } from '../objects/svg/finish/svgfinish27';
import { SVGFinish28 } from '../objects/svg/finish/svgfinish28';
import { SVGFinish3 } from '../objects/svg/finish/svgfinish3';
import { SVGFinish4 } from '../objects/svg/finish/svgfinish4';
import { SVGFinish5 } from '../objects/svg/finish/svgfinish5';
import { SVGFinish6 } from '../objects/svg/finish/svgfinish6';
import { SVGFinish7 } from '../objects/svg/finish/svgfinish7';
import { SVGFinish8 } from '../objects/svg/finish/svgfinish8';
import { SVGFinish9 } from '../objects/svg/finish/svgfinish9';
import { SVGFlex1 } from '../objects/svg/flex/svgflex1';
import { SVGFlex10 } from '../objects/svg/flex/svgflex10';
import { SVGFlex2 } from '../objects/svg/flex/svgflex2';
import { SVGFlex3 } from '../objects/svg/flex/svgflex3';
import { SVGFlex4 } from '../objects/svg/flex/svgflex4';
import { SVGFlex5 } from '../objects/svg/flex/svgflex5';
import { SVGFlex6 } from '../objects/svg/flex/svgflex6';
import { SVGFlex7 } from '../objects/svg/flex/svgflex7';
import { SVGFlex8 } from '../objects/svg/flex/svgflex8';
import { SVGFlex9 } from '../objects/svg/flex/svgflex9';
import { SVGFlow1 } from '../objects/svg/flow/svgflow1';
import { SVGFlow10 } from '../objects/svg/flow/svgflow10';
import { SVGFlow11 } from '../objects/svg/flow/svgflow11';
import { SVGFlow12 } from '../objects/svg/flow/svgflow12';
import { SVGFlow13 } from '../objects/svg/flow/svgflow13';
import { SVGFlow14 } from '../objects/svg/flow/svgflow14';
import { SVGFlow2 } from '../objects/svg/flow/svgflow2';
import { SVGFlow3 } from '../objects/svg/flow/svgflow3';
import { SVGFlow4 } from '../objects/svg/flow/svgflow4';
import { SVGFlow5 } from '../objects/svg/flow/svgflow5';
import { SVGFlow6 } from '../objects/svg/flow/svgflow6';
import { SVGFlow7 } from '../objects/svg/flow/svgflow7';
import { SVGFlow8 } from '../objects/svg/flow/svgflow8';
import { SVGFlow9 } from '../objects/svg/flow/svgflow9';
import { SVGFood1 } from '../objects/svg/food/svgfood1';
import { SVGFood10 } from '../objects/svg/food/svgfood10';
import { SVGFood11 } from '../objects/svg/food/svgfood11';
import { SVGFood12 } from '../objects/svg/food/svgfood12';
import { SVGFood13 } from '../objects/svg/food/svgfood13';
import { SVGFood14 } from '../objects/svg/food/svgfood14';
import { SVGFood15 } from '../objects/svg/food/svgfood15';
import { SVGFood16 } from '../objects/svg/food/svgfood16';
import { SVGFood17 } from '../objects/svg/food/svgfood17';
import { SVGFood18 } from '../objects/svg/food/svgfood18';
import { SVGFood19 } from '../objects/svg/food/svgfood19';
import { SVGFood2 } from '../objects/svg/food/svgfood2';
import { SVGFood20 } from '../objects/svg/food/svgfood20';
import { SVGFood21 } from '../objects/svg/food/svgfood21';
import { SVGFood22 } from '../objects/svg/food/svgfood22';
import { SVGFood23 } from '../objects/svg/food/svgfood23';
import { SVGFood24 } from '../objects/svg/food/svgfood24';
import { SVGFood25 } from '../objects/svg/food/svgfood25';
import { SVGFood26 } from '../objects/svg/food/svgfood26';
import { SVGFood27 } from '../objects/svg/food/svgfood27';
import { SVGFood28 } from '../objects/svg/food/svgfood28';
import { SVGFood3 } from '../objects/svg/food/svgfood3';
import { SVGFood4 } from '../objects/svg/food/svgfood4';
import { SVGFood5 } from '../objects/svg/food/svgfood5';
import { SVGFood6 } from '../objects/svg/food/svgfood6';
import { SVGFood7 } from '../objects/svg/food/svgfood7';
import { SVGFood8 } from '../objects/svg/food/svgfood8';
import { SVGFood9 } from '../objects/svg/food/svgfood9';
import { SVGHeating1 } from '../objects/svg/heating/svgheating';
import { SVGHeating10 } from '../objects/svg/heating/svgheating10';
import { SVGHeating11 } from '../objects/svg/heating/svgheating11';
import { SVGHeating12 } from '../objects/svg/heating/svgheating12';
import { SVGHeating13 } from '../objects/svg/heating/svgheating13';
import { SVGHeating14 } from '../objects/svg/heating/svgheating14';
import { SVGHeating15 } from '../objects/svg/heating/svgheating15';
import { SVGHeating16 } from '../objects/svg/heating/svgheating16';
import { SVGHeating17 } from '../objects/svg/heating/svgheating17';
import { SVGHeating18 } from '../objects/svg/heating/svgheating18';
import { SVGHeating19 } from '../objects/svg/heating/svgheating19';
import { SVGHeating2 } from '../objects/svg/heating/svgheating2';
import { SVGHeating20 } from '../objects/svg/heating/svgheating20';
import { SVGHeating21 } from '../objects/svg/heating/svgheating21';
import { SVGHeating22 } from '../objects/svg/heating/svgheating22';
import { SVGHeating23 } from '../objects/svg/heating/svgheating23';
import { SVGHeating24 } from '../objects/svg/heating/svgheating24';
import { SVGHeating25 } from '../objects/svg/heating/svgheating25';
import { SVGHeating26 } from '../objects/svg/heating/svgheating26';
import { SVGHeating3 } from '../objects/svg/heating/svgheating3';
import { SVGHeating4 } from '../objects/svg/heating/svgheating4';
import { SVGHeating5 } from '../objects/svg/heating/svgheating5';
import { SVGHeating6 } from '../objects/svg/heating/svgheating6';
import { SVGHeating7 } from '../objects/svg/heating/svgheating7';
import { SVGHeating8 } from '../objects/svg/heating/svgheating8';
import { SVGHeating9 } from '../objects/svg/heating/svgheating9';
import { SVGHvac1 } from '../objects/svg/hvac/svghvac1';
import { SVGHvac10 } from '../objects/svg/hvac/svghvac10';
import { SVGHvac11 } from '../objects/svg/hvac/svghvac11';
import { SVGHvac12 } from '../objects/svg/hvac/svghvac12';
import { SVGHvac13 } from '../objects/svg/hvac/svghvac13';
import { SVGHvac14 } from '../objects/svg/hvac/svghvac14';
import { SVGHvac15 } from '../objects/svg/hvac/svghvac15';
import { SVGHvac16 } from '../objects/svg/hvac/svghvac16';
import { SVGHvac17 } from '../objects/svg/hvac/svghvac17';
import { SVGHvac18 } from '../objects/svg/hvac/svghvac18';
import { SVGHvac19 } from '../objects/svg/hvac/svghvac19';
import { SVGHvac2 } from '../objects/svg/hvac/svghvac2';
import { SVGHvac21 } from '../objects/svg/hvac/svghvac21';
import { SVGHvac22 } from '../objects/svg/hvac/svghvac22';
import { SVGHvac23 } from '../objects/svg/hvac/svghvac23';
import { SVGHvac24 } from '../objects/svg/hvac/svghvac24';
import { SVGHvac25 } from '../objects/svg/hvac/svghvac25';
import { SVGHvac26 } from '../objects/svg/hvac/svghvac26';
import { SVGHvac27 } from '../objects/svg/hvac/svghvac27';
import { SVGHvac28 } from '../objects/svg/hvac/svghvac28';
import { SVGHvac29 } from '../objects/svg/hvac/svghvac29';
import { SVGHvac3 } from '../objects/svg/hvac/svghvac3';
import { SVGHvac30 } from '../objects/svg/hvac/svghvac30';
import { SVGHvac4 } from '../objects/svg/hvac/svghvac4';
import { SVGHvac5 } from '../objects/svg/hvac/svghvac5';
import { SVGHvac6 } from '../objects/svg/hvac/svghvac6';
import { SVGHvac7 } from '../objects/svg/hvac/svghvac7';
import { SVGHvac8 } from '../objects/svg/hvac/svghvac8';
import { SVGHvac9 } from '../objects/svg/hvac/svghvac9';
import { SVGInterface1 } from '../objects/svg/interfaces/svginterface1';
import { SVGInterface10 } from '../objects/svg/interfaces/svginterface10';
import { SVGInterface11 } from '../objects/svg/interfaces/svginterface11';
import { SVGInterface12 } from '../objects/svg/interfaces/svginterface12';
import { SVGInterface13 } from '../objects/svg/interfaces/svginterface13';
import { SVGInterface2 } from '../objects/svg/interfaces/svginterface2';
import { SVGInterface3 } from '../objects/svg/interfaces/svginterface3';
import { SVGInterface4 } from '../objects/svg/interfaces/svginterface4';
import { SVGInterface5 } from '../objects/svg/interfaces/svginterface5';
import { SVGInterface6 } from '../objects/svg/interfaces/svginterface6';
import { SVGInterface7 } from '../objects/svg/interfaces/svginterface7';
import { SVGInterface8 } from '../objects/svg/interfaces/svginterface8';
import { SVGInterface9 } from '../objects/svg/interfaces/svginterface9';
import { SVGLogistic1 } from '../objects/svg/logistic/svglogistic1';
import { SVGLogistic10 } from '../objects/svg/logistic/svglogistic10';
import { SVGLogistic11 } from '../objects/svg/logistic/svglogistic11';
import { SVGLogistic2 } from '../objects/svg/logistic/svglogistic2';
import { SVGLogistic3 } from '../objects/svg/logistic/svglogistic3';
import { SVGLogistic4 } from '../objects/svg/logistic/svglogistic4';
import { SVGLogistic5 } from '../objects/svg/logistic/svglogistic5';
import { SVGLogistic6 } from '../objects/svg/logistic/svglogistic6';
import { SVGLogistic7 } from '../objects/svg/logistic/svglogistic7';
import { SVGLogistic8 } from '../objects/svg/logistic/svglogistic8';
import { SVGLogistic9 } from '../objects/svg/logistic/svglogistic9';
import { SVGMachine1 } from '../objects/svg/machining/svgmachine1';
import { SVGMachine10 } from '../objects/svg/machining/svgmachine10';
import { SVGMachine11 } from '../objects/svg/machining/svgmachine11';
import { SVGMachine12 } from '../objects/svg/machining/svgmachine12';
import { SVGMachine13 } from '../objects/svg/machining/svgmachine13';
import { SVGMachine14 } from '../objects/svg/machining/svgmachine14';
import { SVGMachine15 } from '../objects/svg/machining/svgmachine15';
import { SVGMachine16 } from '../objects/svg/machining/svgmachine16';
import { SVGMachine17 } from '../objects/svg/machining/svgmachine17';
import { SVGMachine18 } from '../objects/svg/machining/svgmachine18';
import { SVGMachine19 } from '../objects/svg/machining/svgmachine19';
import { SVGMachine2 } from '../objects/svg/machining/svgmachine2';
import { SVGMachine20 } from '../objects/svg/machining/svgmachine20';
import { SVGMachine21 } from '../objects/svg/machining/svgmachine21';
import { SVGMachine22 } from '../objects/svg/machining/svgmachine22';
import { SVGMachine23 } from '../objects/svg/machining/svgmachine23';
import { SVGMachine24 } from '../objects/svg/machining/svgmachine24';
import { SVGMachine25 } from '../objects/svg/machining/svgmachine25';
import { SVGMachine26 } from '../objects/svg/machining/svgmachine26';
import { SVGMachine27 } from '../objects/svg/machining/svgmachine27';
import { SVGMachine28 } from '../objects/svg/machining/svgmachine28';
import { SVGMachine29 } from '../objects/svg/machining/svgmachine29';
import { SVGMachine3 } from '../objects/svg/machining/svgmachine3';
import { SVGMachine30 } from '../objects/svg/machining/svgmachine30';
import { SVGMachine31 } from '../objects/svg/machining/svgmachine31';
import { SVGMachine32 } from '../objects/svg/machining/svgmachine32';
import { SVGMachine33 } from '../objects/svg/machining/svgmachine33';
import { SVGMachine34 } from '../objects/svg/machining/svgmachine34';
import { SVGMachine4 } from '../objects/svg/machining/svgmachine4';
import { SVGMachine5 } from '../objects/svg/machining/svgmachine5';
import { SVGMachine6 } from '../objects/svg/machining/svgmachine6';
import { SVGMachine7 } from '../objects/svg/machining/svgmachine7';
import { SVGMachine8 } from '../objects/svg/machining/svgmachine8';
import { SVGMachine9 } from '../objects/svg/machining/svgmachine9';
import { SVGMaterial1 } from '../objects/svg/material/svgmaterial1';
import { SVGMaterial10 } from '../objects/svg/material/svgmaterial10';
import { SVGMaterial11 } from '../objects/svg/material/svgmaterial11';
import { SVGMaterial12 } from '../objects/svg/material/svgmaterial12';
import { SVGMaterial13 } from '../objects/svg/material/svgmaterial13';
import { SVGMaterial14 } from '../objects/svg/material/svgmaterial14';
import { SVGMaterial15 } from '../objects/svg/material/svgmaterial15';
import { SVGMaterial16 } from '../objects/svg/material/svgmaterial16';
import { SVGMaterial17 } from '../objects/svg/material/svgmaterial17';
import { SVGMaterial18 } from '../objects/svg/material/svgmaterial18';
import { SVGMaterial19 } from '../objects/svg/material/svgmaterial19';
import { SVGMaterial2 } from '../objects/svg/material/svgmaterial2';
import { SVGMaterial20 } from '../objects/svg/material/svgmaterial20';
import { SVGMaterial21 } from '../objects/svg/material/svgmaterial21';
import { SVGMaterial22 } from '../objects/svg/material/svgmaterial22';
import { SVGMaterial23 } from '../objects/svg/material/svgmaterial23';
import { SVGMaterial24 } from '../objects/svg/material/svgmaterial24';
import { SVGMaterial25 } from '../objects/svg/material/svgmaterial25';
import { SVGMaterial26 } from '../objects/svg/material/svgmaterial26';
import { SVGMaterial27 } from '../objects/svg/material/svgmaterial27';
import { SVGMaterial28 } from '../objects/svg/material/svgmaterial28';
import { SVGMaterial29 } from '../objects/svg/material/svgmaterial29';
import { SVGMaterial3 } from '../objects/svg/material/svgmaterial3';
import { SVGMaterial30 } from '../objects/svg/material/svgmaterial30';
import { SVGMaterial31 } from '../objects/svg/material/svgmaterial31';
import { SVGMaterial32 } from '../objects/svg/material/svgmaterial32';
import { SVGMaterial33 } from '../objects/svg/material/svgmaterial33';
import { SVGMaterial4 } from '../objects/svg/material/svgmaterial4';
import { SVGMaterial5 } from '../objects/svg/material/svgmaterial5';
import { SVGMaterial6 } from '../objects/svg/material/svgmaterial6';
import { SVGMaterial7 } from '../objects/svg/material/svgmaterial7';
import { SVGMaterial8 } from '../objects/svg/material/svgmaterial8';
import { SVGMaterial9 } from '../objects/svg/material/svgmaterial9';
import { SVGMedical1 } from '../objects/svg/medical/svgmedical1';
import { SVGMedical10 } from '../objects/svg/medical/svgmedical10';
import { SVGMedical11 } from '../objects/svg/medical/svgmedical11';
import { SVGMedical12 } from '../objects/svg/medical/svgmedical12';
import { SVGMedical13 } from '../objects/svg/medical/svgmedical13';
import { SVGMedical2 } from '../objects/svg/medical/svgmedical2';
import { SVGMedical3 } from '../objects/svg/medical/svgmedical3';
import { SVGMedical4 } from '../objects/svg/medical/svgmedical4';
import { SVGMedical5 } from '../objects/svg/medical/svgmedical5';
import { SVGMedical6 } from '../objects/svg/medical/svgmedical6';
import { SVGMedical7 } from '../objects/svg/medical/svgmedical7';
import { SVGMedical8 } from '../objects/svg/medical/svgmedical8';
import { SVGMedical9 } from '../objects/svg/medical/svgmedical9';
import { SVGMining1 } from '../objects/svg/mining/svgmining1';
import { SVGMining10 } from '../objects/svg/mining/svgmining10';
import { SVGMining11 } from '../objects/svg/mining/svgmining11';
import { SVGMining12 } from '../objects/svg/mining/svgmining12';
import { SVGMining13 } from '../objects/svg/mining/svgmining13';
import { SVGMining14 } from '../objects/svg/mining/svgmining14';
import { SVGMining15 } from '../objects/svg/mining/svgmining15';
import { SVGMining16 } from '../objects/svg/mining/svgmining16';
import { SVGMining17 } from '../objects/svg/mining/svgmining17';
import { SVGMining18 } from '../objects/svg/mining/svgmining18';
import { SVGMining19 } from '../objects/svg/mining/svgmining19';
import { SVGMining2 } from '../objects/svg/mining/svgmining2';
import { SVGMining20 } from '../objects/svg/mining/svgmining20';
import { SVGMining21 } from '../objects/svg/mining/svgmining21';
import { SVGMining22 } from '../objects/svg/mining/svgmining22';
import { SVGMining23 } from '../objects/svg/mining/svgmining23';
import { SVGMining24 } from '../objects/svg/mining/svgmining24';
import { SVGMining25 } from '../objects/svg/mining/svgmining25';
import { SVGMining26 } from '../objects/svg/mining/svgmining26';
import { SVGMining27 } from '../objects/svg/mining/svgmining27';
import { SVGMining28 } from '../objects/svg/mining/svgmining28';
import { SVGMining29 } from '../objects/svg/mining/svgmining29';
import { SVGMining3 } from '../objects/svg/mining/svgmining3';
import { SVGMining30 } from '../objects/svg/mining/svgmining30';
import { SVGMining31 } from '../objects/svg/mining/svgmining31';
import { SVGMining32 } from '../objects/svg/mining/svgmining32';
import { SVGMining33 } from '../objects/svg/mining/svgmining33';
import { SVGMining4 } from '../objects/svg/mining/svgmining4';
import { SVGMining5 } from '../objects/svg/mining/svgmining5';
import { SVGMining6 } from '../objects/svg/mining/svgmining6';
import { SVGMining7 } from '../objects/svg/mining/svgmining7';
import { SVGMining8 } from '../objects/svg/mining/svgmining8';
import { SVGMining9 } from '../objects/svg/mining/svgmining9';
import { SVGMiscpipe1 } from '../objects/svg/miscpipes/svgmiscpipe1';
import { SVGMiscpipe10 } from '../objects/svg/miscpipes/svgmiscpipe10';
import { SVGMiscpipe11 } from '../objects/svg/miscpipes/svgmiscpipe11';
import { SVGMiscpipe12 } from '../objects/svg/miscpipes/svgmiscpipe12';
import { SVGMiscpipe2 } from '../objects/svg/miscpipes/svgmiscpipe2';
import { SVGMiscpipe3 } from '../objects/svg/miscpipes/svgmiscpipe3';
import { SVGMiscpipe4 } from '../objects/svg/miscpipes/svgmiscpipe4';
import { SVGMiscpipe5 } from '../objects/svg/miscpipes/svgmiscpipe5';
import { SVGMiscpipe6 } from '../objects/svg/miscpipes/svgmiscpipe6';
import { SVGMiscpipe7 } from '../objects/svg/miscpipes/svgmiscpipe7';
import { SVGMiscpipe8 } from '../objects/svg/miscpipes/svgmiscpipe8';
import { SVGMiscpipe9 } from '../objects/svg/miscpipes/svgmiscpipe9';
import { SVGMixer1 } from '../objects/svg/mixers/svgmixer1';
import { SVGMixer10 } from '../objects/svg/mixers/svgmixer10';
import { SVGMixer11 } from '../objects/svg/mixers/svgmixer11';
import { SVGMixer2 } from '../objects/svg/mixers/svgmixer2';
import { SVGMixer3 } from '../objects/svg/mixers/svgmixer3';
import { SVGMixer4 } from '../objects/svg/mixers/svgmixer4';
import { SVGMixer5 } from '../objects/svg/mixers/svgmixer5';
import { SVGMixer6 } from '../objects/svg/mixers/svgmixer6';
import { SVGMixer7 } from '../objects/svg/mixers/svgmixer7';
import { SVGMixer8 } from '../objects/svg/mixers/svgmixer8';
import { SVGMixer9 } from '../objects/svg/mixers/svgmixer9';
import { SVGMotor1 } from '../objects/svg/motors/svgmotor1';
import { SVGMotor10 } from '../objects/svg/motors/svgmotor10';
import { SVGMotor11 } from '../objects/svg/motors/svgmotor11';
import { SVGMotor12 } from '../objects/svg/motors/svgmotor12';
import { SVGMotor13 } from '../objects/svg/motors/svgmotor13';
import { SVGMotor14 } from '../objects/svg/motors/svgmotor14';
import { SVGMotor15 } from '../objects/svg/motors/svgmotor15';
import { SVGMotor16 } from '../objects/svg/motors/svgmotor16';
import { SVGMotor2 } from '../objects/svg/motors/svgmotor2';
import { SVGMotor3 } from '../objects/svg/motors/svgmotor3';
import { SVGMotor4 } from '../objects/svg/motors/svgmotor4';
import { SVGMotor5 } from '../objects/svg/motors/svgmotor5';
import { SVGMotor6 } from '../objects/svg/motors/svgmotor6';
import { SVGMotor7 } from '../objects/svg/motors/svgmotor7';
import { SVGMotor8 } from '../objects/svg/motors/svgmotor8';
import { SVGMotor9 } from '../objects/svg/motors/svgmotor9';
import { SVGNature1 } from '../objects/svg/nature/svgnature1';
import { SVGNature10 } from '../objects/svg/nature/svgnature10';
import { SVGNature11 } from '../objects/svg/nature/svgnature11';
import { SVGNature12 } from '../objects/svg/nature/svgnature12';
import { SVGNature13 } from '../objects/svg/nature/svgnature13';
import { SVGNature14 } from '../objects/svg/nature/svgnature14';
import { SVGNature15 } from '../objects/svg/nature/svgnature15';
import { SVGNature2 } from '../objects/svg/nature/svgnature2';
import { SVGNature3 } from '../objects/svg/nature/svgnature3';
import { SVGNature4 } from '../objects/svg/nature/svgnature4';
import { SVGNature5 } from '../objects/svg/nature/svgnature5';
import { SVGNature6 } from '../objects/svg/nature/svgnature6';
import { SVGNature7 } from '../objects/svg/nature/svgnature7';
import { SVGNature8 } from '../objects/svg/nature/svgnature8';
import { SVGNature9 } from '../objects/svg/nature/svgnature9';
import { SVGNet1 } from '../objects/svg/networking/svgnet1';
import { SVGNet10 } from '../objects/svg/networking/svgnet10';
import { SVGNet11 } from '../objects/svg/networking/svgnet11';
import { SVGNet12 } from '../objects/svg/networking/svgnet12';
import { SVGNet13 } from '../objects/svg/networking/svgnet13';
import { SVGNet14 } from '../objects/svg/networking/svgnet14';
import { SVGNet15 } from '../objects/svg/networking/svgnet15';
import { SVGNet16 } from '../objects/svg/networking/svgnet16';
import { SVGNet17 } from '../objects/svg/networking/svgnet17';
import { SVGNet18 } from '../objects/svg/networking/svgnet18';
import { SVGNet19 } from '../objects/svg/networking/svgnet19';
import { SVGNet2 } from '../objects/svg/networking/svgnet2';
import { SVGNet3 } from '../objects/svg/networking/svgnet3';
import { SVGNet4 } from '../objects/svg/networking/svgnet4';
import { SVGNet5 } from '../objects/svg/networking/svgnet5';
import { SVGNet6 } from '../objects/svg/networking/svgnet6';
import { SVGNet7 } from '../objects/svg/networking/svgnet7';
import { SVGNet8 } from '../objects/svg/networking/svgnet8';
import { SVGNet9 } from '../objects/svg/networking/svgnet9';
import { SVGNuclear1 } from '../objects/svg/nuclear/svgnuclear1';
import { SVGNuclear2 } from '../objects/svg/nuclear/svgnuclear2';
import { SVGNuclear3 } from '../objects/svg/nuclear/svgnuclear3';
import { SVGNuclear4 } from '../objects/svg/nuclear/svgnuclear4';
import { SVGNuclear5 } from '../objects/svg/nuclear/svgnuclear5';
import { SVGNuclear6 } from '../objects/svg/nuclear/svgnuclear6';
import { SVGNuclear7 } from '../objects/svg/nuclear/svgnuclear7';
import { SVGPanel1 } from '../objects/svg/panels/svgpanel';
import { SVGPanel2 } from '../objects/svg/panels/svgpanel2';
import { SVGPanel3 } from '../objects/svg/panels/svgpanel3';
import { SVGPanel4 } from '../objects/svg/panels/svgpanel4';
import { SVGPanel5 } from '../objects/svg/panels/svgpanel5';
import { SVGPanel6 } from '../objects/svg/panels/svgpanel6';
import { SVGPanel7 } from '../objects/svg/panels/svgpanel7';
import { SVGPanel8 } from '../objects/svg/panels/svgpanel8';
import { SVGPaper1 } from '../objects/svg/papers/svgpaper1';
import { SVGPaper10 } from '../objects/svg/papers/svgpaper10';
import { SVGPaper11 } from '../objects/svg/papers/svgpaper11';
import { SVGPaper12 } from '../objects/svg/papers/svgpaper12';
import { SVGPaper13 } from '../objects/svg/papers/svgpaper13';
import { SVGPaper14 } from '../objects/svg/papers/svgpaper14';
import { SVGPaper15 } from '../objects/svg/papers/svgpaper15';
import { SVGPaper16 } from '../objects/svg/papers/svgpaper16';
import { SVGPaper17 } from '../objects/svg/papers/svgpaper17';
import { SVGPaper18 } from '../objects/svg/papers/svgpaper18';
import { SVGPaper19 } from '../objects/svg/papers/svgpaper19';
import { SVGPaper2 } from '../objects/svg/papers/svgpaper2';
import { SVGPaper3 } from '../objects/svg/papers/svgpaper3';
import { SVGPaper4 } from '../objects/svg/papers/svgpaper4';
import { SVGPaper5 } from '../objects/svg/papers/svgpaper5';
import { SVGPaper6 } from '../objects/svg/papers/svgpaper6';
import { SVGPaper7 } from '../objects/svg/papers/svgpaper7';
import { SVGPaper8 } from '../objects/svg/papers/svgpaper8';
import { SVGPaper9 } from '../objects/svg/papers/svgpaper9';
import { SVGPeople1 } from '../objects/svg/people/svgpeople1';
import { SVGPeople10 } from '../objects/svg/people/svgpeople10';
import { SVGPeople2 } from '../objects/svg/people/svgpeople2';
import { SVGPeople3 } from '../objects/svg/people/svgpeople3';
import { SVGPeople4 } from '../objects/svg/people/svgpeople4';
import { SVGPeople5 } from '../objects/svg/people/svgpeople5';
import { SVGPeople6 } from '../objects/svg/people/svgpeople6';
import { SVGPeople7 } from '../objects/svg/people/svgpeople7';
import { SVGPeople8 } from '../objects/svg/people/svgpeople8';
import { SVGPeople9 } from '../objects/svg/people/svgpeople9';
import { SVGPipe1 } from '../objects/svg/pipes/svgpipe1';
import { SVGPipe10 } from '../objects/svg/pipes/svgpipe10';
import { SVGPipe11 } from '../objects/svg/pipes/svgpipe11';
import { SVGPipe12 } from '../objects/svg/pipes/svgpipe12';
import { SVGPipe13 } from '../objects/svg/pipes/svgpipe13';
import { SVGPipe14 } from '../objects/svg/pipes/svgpipe14';
import { SVGPipe15 } from '../objects/svg/pipes/svgpipe15';
import { SVGPipe16 } from '../objects/svg/pipes/svgpipe16';
import { SVGPipe17 } from '../objects/svg/pipes/svgpipe17';
import { SVGPipe18 } from '../objects/svg/pipes/svgpipe18';
import { SVGPipe19 } from '../objects/svg/pipes/svgpipe19';
import { SVGPipe2 } from '../objects/svg/pipes/svgpipe2';
import { SVGPipe20 } from '../objects/svg/pipes/svgpipe20';
import { SVGPipe21 } from '../objects/svg/pipes/svgpipe21';
import { SVGPipe22 } from '../objects/svg/pipes/svgpipe22';
import { SVGPipe23 } from '../objects/svg/pipes/svgpipe23';
import { SVGPipe24 } from '../objects/svg/pipes/svgpipe24';
import { SVGPipe25 } from '../objects/svg/pipes/svgpipe25';
import { SVGPipe26 } from '../objects/svg/pipes/svgpipe26';
import { SVGPipe3 } from '../objects/svg/pipes/svgpipe3';
import { SVGPipe4 } from '../objects/svg/pipes/svgpipe4';
import { SVGPipe5 } from '../objects/svg/pipes/svgpipe5';
import { SVGPipe6 } from '../objects/svg/pipes/svgpipe6';
import { SVGPipe7 } from '../objects/svg/pipes/svgpipe7';
import { SVGPipe8 } from '../objects/svg/pipes/svgpipe8';
import { SVGPipe9 } from '../objects/svg/pipes/svgpipe9';
import { SVGPlant1 } from '../objects/svg/plant/svgplant1';
import { SVGPlant10 } from '../objects/svg/plant/svgplant10';
import { SVGPlant11 } from '../objects/svg/plant/svgplant11';
import { SVGPlant12 } from '../objects/svg/plant/svgplant12';
import { SVGPlant13 } from '../objects/svg/plant/svgplant13';
import { SVGPlant14 } from '../objects/svg/plant/svgplant14';
import { SVGPlant15 } from '../objects/svg/plant/svgplant15';
import { SVGPlant16 } from '../objects/svg/plant/svgplant16';
import { SVGPlant17 } from '../objects/svg/plant/svgplant17';
import { SVGPlant18 } from '../objects/svg/plant/svgplant18';
import { SVGPlant19 } from '../objects/svg/plant/svgplant19';
import { SVGPlant2 } from '../objects/svg/plant/svgplant2';
import { SVGPlant20 } from '../objects/svg/plant/svgplant20';
import { SVGPlant21 } from '../objects/svg/plant/svgplant21';
import { SVGPlant22 } from '../objects/svg/plant/svgplant22';
import { SVGPlant23 } from '../objects/svg/plant/svgplant23';
import { SVGPlant24 } from '../objects/svg/plant/svgplant24';
import { SVGPlant25 } from '../objects/svg/plant/svgplant25';
import { SVGPlant26 } from '../objects/svg/plant/svgplant26';
import { SVGPlant27 } from '../objects/svg/plant/svgplant27';
import { SVGPlant3 } from '../objects/svg/plant/svgplant3';
import { SVGPlant4 } from '../objects/svg/plant/svgplant4';
import { SVGPlant5 } from '../objects/svg/plant/svgplant5';
import { SVGPlant6 } from '../objects/svg/plant/svgplant6';
import { SVGPlant7 } from '../objects/svg/plant/svgplant7';
import { SVGPlant8 } from '../objects/svg/plant/svgplant8';
import { SVGPlant9 } from '../objects/svg/plant/svgplant9';
import { SVGPower1 } from '../objects/svg/power/svgpower1';
import { SVGPower10 } from '../objects/svg/power/svgpower10';
import { SVGPower11 } from '../objects/svg/power/svgpower11';
import { SVGPower12 } from '../objects/svg/power/svgpower12';
import { SVGPower13 } from '../objects/svg/power/svgpower13';
import { SVGPower14 } from '../objects/svg/power/svgpower14';
import { SVGPower15 } from '../objects/svg/power/svgpower15';
import { SVGPower16 } from '../objects/svg/power/svgpower16';
import { SVGPower2 } from '../objects/svg/power/svgpower2';
import { SVGPower3 } from '../objects/svg/power/svgpower3';
import { SVGPower4 } from '../objects/svg/power/svgpower4';
import { SVGPower5 } from '../objects/svg/power/svgpower5';
import { SVGPower6 } from '../objects/svg/power/svgpower6';
import { SVGPower7 } from '../objects/svg/power/svgpower7';
import { SVGPower8 } from '../objects/svg/power/svgpower8';
import { SVGPower9 } from '../objects/svg/power/svgpower9';
import { SVGPump1 } from '../objects/svg/pumps/svgpump1';
import { SVGPump10 } from '../objects/svg/pumps/svgpump10';
import { SVGPump11 } from '../objects/svg/pumps/svgpump11';
import { SVGPump12 } from '../objects/svg/pumps/svgpump12';
import { SVGPump13 } from '../objects/svg/pumps/svgpump13';
import { SVGPump14 } from '../objects/svg/pumps/svgpump14';
import { SVGPump15 } from '../objects/svg/pumps/svgpump15';
import { SVGPump16 } from '../objects/svg/pumps/svgpump16';
import { SVGPump17 } from '../objects/svg/pumps/svgpump17';
import { SVGPump18 } from '../objects/svg/pumps/svgpump18';
import { SVGPump19 } from '../objects/svg/pumps/svgpump19';
import { SVGPump2 } from '../objects/svg/pumps/svgpump2';
import { SVGPump20 } from '../objects/svg/pumps/svgpump20';
import { SVGPump21 } from '../objects/svg/pumps/svgpump21';
import { SVGPump22 } from '../objects/svg/pumps/svgpump22';
import { SVGPump23 } from '../objects/svg/pumps/svgpump23';
import { SVGPump24 } from '../objects/svg/pumps/svgpump24';
import { SVGPump3 } from '../objects/svg/pumps/svgpump3';
import { SVGPump4 } from '../objects/svg/pumps/svgpump4';
import { SVGPump5 } from '../objects/svg/pumps/svgpump5';
import { SVGPump6 } from '../objects/svg/pumps/svgpump6';
import { SVGPump7 } from '../objects/svg/pumps/svgpump7';
import { SVGPump8 } from '../objects/svg/pumps/svgpump8';
import { SVGPump9 } from '../objects/svg/pumps/svgpump9';
import { SVGEnergy1 } from '../objects/svg/renewenergy/svgenergy1';
import { SVGEnergy2 } from '../objects/svg/renewenergy/svgenergy2';
import { SVGEnergy3 } from '../objects/svg/renewenergy/svgenergy3';
import { SVGEnergy4 } from '../objects/svg/renewenergy/svgenergy4';
import { SVGEnergy5 } from '../objects/svg/renewenergy/svgenergy5';
import { SVGEnergy6 } from '../objects/svg/renewenergy/svgenergy6';
import { SVGEnergy7 } from '../objects/svg/renewenergy/svgenergy7';
import { SVGScale1 } from '../objects/svg/scales/svgscale1';
import { SVGScale2 } from '../objects/svg/scales/svgscale2';
import { SVGScale3 } from '../objects/svg/scales/svgscale3';
import { SVGScale4 } from '../objects/svg/scales/svgscale4';
import { SVGSegpipe1 } from '../objects/svg/segpipes/svgsegpipe1';
import { SVGSegpipe10 } from '../objects/svg/segpipes/svgsegpipe10';
import { SVGSegpipe11 } from '../objects/svg/segpipes/svgsegpipe11';
import { SVGSegpipe12 } from '../objects/svg/segpipes/svgsegpipe12';
import { SVGSegpipe13 } from '../objects/svg/segpipes/svgsegpipe13';
import { SVGSegpipe14 } from '../objects/svg/segpipes/svgsegpipe14';
import { SVGSegpipe2 } from '../objects/svg/segpipes/svgsegpipe2';
import { SVGSegpipe3 } from '../objects/svg/segpipes/svgsegpipe3';
import { SVGSegpipe4 } from '../objects/svg/segpipes/svgsegpipe4';
import { SVGSegpipe5 } from '../objects/svg/segpipes/svgsegpipe5';
import { SVGSegpipe6 } from '../objects/svg/segpipes/svgsegpipe6';
import { SVGSegpipe7 } from '../objects/svg/segpipes/svgsegpipe7';
import { SVGSegpipe8 } from '../objects/svg/segpipes/svgsegpipe8';
import { SVGSegpipe9 } from '../objects/svg/segpipes/svgsegpipe9';
import { SVGSensor1 } from '../objects/svg/sensors/svgsensor1';
import { SVGSensor10 } from '../objects/svg/sensors/svgsensor10';
import { SVGSensor11 } from '../objects/svg/sensors/svgsensor11';
import { SVGSensor12 } from '../objects/svg/sensors/svgsensor12';
import { SVGSensor13 } from '../objects/svg/sensors/svgsensor13';
import { SVGSensor14 } from '../objects/svg/sensors/svgsensor14';
import { SVGSensor15 } from '../objects/svg/sensors/svgsensor15';
import { SVGSensor16 } from '../objects/svg/sensors/svgsensor16';
import { SVGSensor17 } from '../objects/svg/sensors/svgsensor17';
import { SVGSensor18 } from '../objects/svg/sensors/svgsensor18';
import { SVGSensor19 } from '../objects/svg/sensors/svgsensor19';
import { SVGSensor2 } from '../objects/svg/sensors/svgsensor2';
import { SVGSensor20 } from '../objects/svg/sensors/svgsensor20';
import { SVGSensor3 } from '../objects/svg/sensors/svgsensor3';
import { SVGSensor4 } from '../objects/svg/sensors/svgsensor4';
import { SVGSensor5 } from '../objects/svg/sensors/svgsensor5';
import { SVGSensor6 } from '../objects/svg/sensors/svgsensor6';
import { SVGSensor7 } from '../objects/svg/sensors/svgsensor7';
import { SVGSensor8 } from '../objects/svg/sensors/svgsensor8';
import { SVGSensor9 } from '../objects/svg/sensors/svgsensor9';
import { SVGSymbol1 } from '../objects/svg/symbols/svgsymbol1';
import { SVGSymbol10 } from '../objects/svg/symbols/svgsymbol10';
import { SVGSymbol11 } from '../objects/svg/symbols/svgsymbol11';
import { SVGSymbol12 } from '../objects/svg/symbols/svgsymbol12';
import { SVGSymbol13 } from '../objects/svg/symbols/svgsymbol13';
import { SVGSymbol14 } from '../objects/svg/symbols/svgsymbol14';
import { SVGSymbol2 } from '../objects/svg/symbols/svgsymbol2';
import { SVGSymbol3 } from '../objects/svg/symbols/svgsymbol3';
import { SVGSymbol4 } from '../objects/svg/symbols/svgsymbol4';
import { SVGSymbol5 } from '../objects/svg/symbols/svgsymbol5';
import { SVGSymbol6 } from '../objects/svg/symbols/svgsymbol6';
import { SVGSymbol7 } from '../objects/svg/symbols/svgsymbol7';
import { SVGSymbol8 } from '../objects/svg/symbols/svgsymbol8';
import { SVGSymbol9 } from '../objects/svg/symbols/svgsymbol9';
import { Reactor1 } from '../objects/svg/tanks/reactor1';
import { Reactor10 } from '../objects/svg/tanks/reactor10';
import { Reactor2 } from '../objects/svg/tanks/reactor2';
import { Reactor4 } from '../objects/svg/tanks/reactor4';
import { Reactor5 } from '../objects/svg/tanks/reactor5';
import { Reactor6 } from '../objects/svg/tanks/reactor6';
import { Reactor7 } from '../objects/svg/tanks/reactor7';
import { Reactor8 } from '../objects/svg/tanks/reactor8';
import { Reactor9 } from '../objects/svg/tanks/reactor9';
import { ReactorTank } from '../objects/svg/tanks/reactortank';
import { SVGTank } from '../objects/svg/tanks/svgtank';
import { SVGTank10 } from '../objects/svg/tanks/svgtank10';
import { SVGTank11 } from '../objects/svg/tanks/svgtank11';
import { SVGTank12 } from '../objects/svg/tanks/svgtank12';
import { SVGTank13 } from '../objects/svg/tanks/svgtank13';
import { SVGTank14 } from '../objects/svg/tanks/svgtank14';
import { SVGTank15 } from '../objects/svg/tanks/svgtank15';
import { SVGTank16 } from '../objects/svg/tanks/svgtank16';
import { SVGTank17 } from '../objects/svg/tanks/svgtank17';
import { SVGTank18 } from '../objects/svg/tanks/svgtank18';
import { SVGTank19 } from '../objects/svg/tanks/svgtank19';
import { SVGTank2 } from '../objects/svg/tanks/svgtank2';
import { SVGTank20 } from '../objects/svg/tanks/svgtank20';
import { SVGTank21 } from '../objects/svg/tanks/svgtank21';
import { SVGTank22 } from '../objects/svg/tanks/svgtank22';
import { SVGTank23 } from '../objects/svg/tanks/svgtank23';
import { SVGTank24 } from '../objects/svg/tanks/svgtank24';
import { SVGTank25 } from '../objects/svg/tanks/svgtank25';
import { SVGTank26 } from '../objects/svg/tanks/svgtank26';
import { SVGTank27 } from '../objects/svg/tanks/svgtank27';
import { SVGTank28 } from '../objects/svg/tanks/svgtank28';
import { SVGTank29 } from '../objects/svg/tanks/svgtank29';
import { SVGTank3 } from '../objects/svg/tanks/svgtank3';
import { SVGTank30 } from '../objects/svg/tanks/svgtank30';
import { SVGTank32 } from '../objects/svg/tanks/svgtank32';
import { SVGTank33 } from '../objects/svg/tanks/svgtank33';
import { SVGTank34 } from '../objects/svg/tanks/svgtank34';
import { SVGTank35 } from '../objects/svg/tanks/svgtank35';
import { SVGTank36 } from '../objects/svg/tanks/svgtank36';
import { SVGTank37 } from '../objects/svg/tanks/svgtank37';
import { SVGTank38 } from '../objects/svg/tanks/svgtank38';
import { SVGTank39 } from '../objects/svg/tanks/svgtank39';
import { SVGTank4 } from '../objects/svg/tanks/svgtank4';
import { SVGTank40 } from '../objects/svg/tanks/svgtank40';
import { SVGTank41 } from '../objects/svg/tanks/svgtank41';
import { SVGTank42 } from '../objects/svg/tanks/svgtank42';
import { SVGTank43 } from '../objects/svg/tanks/svgtank43';
import { SVGTank44 } from '../objects/svg/tanks/svgtank44';
import { SVGTank45 } from '../objects/svg/tanks/svgtank45';
import { SVGTank46 } from '../objects/svg/tanks/svgtank46';
import { SVGTank47 } from '../objects/svg/tanks/svgtank47';
import { SVGTank48 } from '../objects/svg/tanks/svgtank48';
import { SVGTank49 } from '../objects/svg/tanks/svgtank49';
import { SVGTank5 } from '../objects/svg/tanks/svgtank5';
import { SVGTank50 } from '../objects/svg/tanks/svgtank50';
import { SVGTank51 } from '../objects/svg/tanks/svgtank51';
import { SVGTank52 } from '../objects/svg/tanks/svgtank52';
import { SVGTank53 } from '../objects/svg/tanks/svgtank53';
import { SVGTank54 } from '../objects/svg/tanks/svgtank54';
import { SVGTank55 } from '../objects/svg/tanks/svgtank55';
import { SVGTank56 } from '../objects/svg/tanks/svgtank56';
import { SVGTank57 } from '../objects/svg/tanks/svgtank57';
import { SVGTank58 } from '../objects/svg/tanks/svgtank58';
import { SVGTank59 } from '../objects/svg/tanks/svgtank59';
import { SVGTank6 } from '../objects/svg/tanks/svgtank6';
import { SVGTank60 } from '../objects/svg/tanks/svgtank60';
import { SVGTank61 } from '../objects/svg/tanks/svgtank61';
import { SVGTank62 } from '../objects/svg/tanks/svgtank62';
import { SVGTank63 } from '../objects/svg/tanks/svgtank63';
import { SVGTank64 } from '../objects/svg/tanks/svgtank64';
import { SVGTank65 } from '../objects/svg/tanks/svgtank65';
import { SVGTank66 } from '../objects/svg/tanks/svgtank66';
import { SVGTank67 } from '../objects/svg/tanks/svgtank67';
import { SVGTank68 } from '../objects/svg/tanks/svgtank68';
import { SVGTank69 } from '../objects/svg/tanks/svgtank69';
import { SVGTank7 } from '../objects/svg/tanks/svgtank7';
import { SVGTank70 } from '../objects/svg/tanks/svgtank70';
import { SVGTank71 } from '../objects/svg/tanks/svgtank71';
import { SVGTank72 } from '../objects/svg/tanks/svgtank72';
import { SVGTank8 } from '../objects/svg/tanks/svgtank8';
import { SVGTank9 } from '../objects/svg/tanks/svgtank9';
import { SVGValve1 } from '../objects/svg/valves/svgvalve1';
import { SVGValve10 } from '../objects/svg/valves/svgvalve10';
import { SVGValve11 } from '../objects/svg/valves/svgvalve11';
import { SVGValve12 } from '../objects/svg/valves/svgvalve12';
import { SVGValve13 } from '../objects/svg/valves/svgvalve13';
import { SVGValve14 } from '../objects/svg/valves/svgvalve14';
import { SVGValve15 } from '../objects/svg/valves/svgvalve15';
import { SVGValve16 } from '../objects/svg/valves/svgvalve16';
import { SVGValve17 } from '../objects/svg/valves/svgvalve17';
import { SVGValve18 } from '../objects/svg/valves/svgvalve18';
import { SVGValve19 } from '../objects/svg/valves/svgvalve19';
import { SVGValve2 } from '../objects/svg/valves/svgvalve2';
import { SVGValve20 } from '../objects/svg/valves/svgvalve20';
import { SVGValve21 } from '../objects/svg/valves/svgvalve21';
import { SVGValve22 } from '../objects/svg/valves/svgvalve22';
import { SVGValve23 } from '../objects/svg/valves/svgvalve23';
import { SVGValve24 } from '../objects/svg/valves/svgvalve24';
import { SVGValve25 } from '../objects/svg/valves/svgvalve25';
import { SVGValve26 } from '../objects/svg/valves/svgvalve26';
import { SVGValve27 } from '../objects/svg/valves/svgvalve27';
import { SVGValve28 } from '../objects/svg/valves/svgvalve28';
import { SVGValve29 } from '../objects/svg/valves/svgvalve29';
import { SVGValve3 } from '../objects/svg/valves/svgvalve3';
import { SVGValve4 } from '../objects/svg/valves/svgvalve4';
import { SVGValve5 } from '../objects/svg/valves/svgvalve5';
import { SVGValve6 } from '../objects/svg/valves/svgvalve6';
import { SVGValve7 } from '../objects/svg/valves/svgvalve7';
import { SVGValve8 } from '../objects/svg/valves/svgvalve8';
import { SVGValve9 } from '../objects/svg/valves/svgvalve9';
import { SVGVehicle1 } from '../objects/svg/vehicles/svgvehicle1';
import { SVGVehicle10 } from '../objects/svg/vehicles/svgvehicle10';
import { SVGVehicle11 } from '../objects/svg/vehicles/svgvehicle11';
import { SVGVehicle12 } from '../objects/svg/vehicles/svgvehicle12';
import { SVGVehicle13 } from '../objects/svg/vehicles/svgvehicle13';
import { SVGVehicle14 } from '../objects/svg/vehicles/svgvehicle14';
import { SVGVehicle15 } from '../objects/svg/vehicles/svgvehicle15';
import { SVGVehicle16 } from '../objects/svg/vehicles/svgvehicle16';
import { SVGVehicle2 } from '../objects/svg/vehicles/svgvehicle2';
import { SVGVehicle3 } from '../objects/svg/vehicles/svgvehicle3';
import { SVGVehicle4 } from '../objects/svg/vehicles/svgvehicle4';
import { SVGVehicle5 } from '../objects/svg/vehicles/svgvehicle5';
import { SVGVehicle6 } from '../objects/svg/vehicles/svgvehicle6';
import { SVGVehicle7 } from '../objects/svg/vehicles/svgvehicle7';
import { SVGVehicle8 } from '../objects/svg/vehicles/svgvehicle8';
import { SVGVehicle9 } from '../objects/svg/vehicles/svgvehicle9';
import { SVGWater1 } from '../objects/svg/water/svgwater1';
import { SVGWater10 } from '../objects/svg/water/svgwater10';
import { SVGWater11 } from '../objects/svg/water/svgwater11';
import { SVGWater12 } from '../objects/svg/water/svgwater12';
import { SVGWater13 } from '../objects/svg/water/svgwater13';
import { SVGWater14 } from '../objects/svg/water/svgwater14';
import { SVGWater15 } from '../objects/svg/water/svgwater15';
import { SVGWater16 } from '../objects/svg/water/svgwater16';
import { SVGWater17 } from '../objects/svg/water/svgwater17';
import { SVGWater18 } from '../objects/svg/water/svgwater18';
import { SVGWater19 } from '../objects/svg/water/svgwater19';
import { SVGWater2 } from '../objects/svg/water/svgwater2';
import { SVGWater20 } from '../objects/svg/water/svgwater20';
import { SVGWater21 } from '../objects/svg/water/svgwater21';
import { SVGWater22 } from '../objects/svg/water/svgwater22';
import { SVGWater23 } from '../objects/svg/water/svgwater23';
import { SVGWater24 } from '../objects/svg/water/svgwater24';
import { SVGWater25 } from '../objects/svg/water/svgwater25';
import { SVGWater26 } from '../objects/svg/water/svgwater26';
import { SVGWater27 } from '../objects/svg/water/svgwater27';
import { SVGWater28 } from '../objects/svg/water/svgwater28';
import { SVGWater29 } from '../objects/svg/water/svgwater29';
import { SVGWater3 } from '../objects/svg/water/svgwater3';
import { SVGWater30 } from '../objects/svg/water/svgwater30';
import { SVGWater31 } from '../objects/svg/water/svgwater31';
import { SVGWater32 } from '../objects/svg/water/svgwater32';
import { SVGWater33 } from '../objects/svg/water/svgwater33';
import { SVGWater34 } from '../objects/svg/water/svgwater34';
import { SVGWater35 } from '../objects/svg/water/svgwater35';
import { SVGWater36 } from '../objects/svg/water/svgwater36';
import { SVGWater37 } from '../objects/svg/water/svgwater37';
import { SVGWater38 } from '../objects/svg/water/svgwater38';
import { SVGWater39 } from '../objects/svg/water/svgwater39';
import { SVGWater4 } from '../objects/svg/water/svgwater4';
import { SVGWater40 } from '../objects/svg/water/svgwater40';
import { SVGWater41 } from '../objects/svg/water/svgwater41';
import { SVGWater42 } from '../objects/svg/water/svgwater42';
import { SVGWater43 } from '../objects/svg/water/svgwater43';
import { SVGWater44 } from '../objects/svg/water/svgwater44';
import { SVGWater45 } from '../objects/svg/water/svgwater45';
import { SVGWater46 } from '../objects/svg/water/svgwater46';
import { SVGWater47 } from '../objects/svg/water/svgwater47';
import { SVGWater48 } from '../objects/svg/water/svgwater48';
import { SVGWater49 } from '../objects/svg/water/svgwater49';
import { SVGWater5 } from '../objects/svg/water/svgwater5';
import { SVGWater50 } from '../objects/svg/water/svgwater50';
import { SVGWater51 } from '../objects/svg/water/svgwater51';
import { SVGWater52 } from '../objects/svg/water/svgwater52';
import { SVGWater53 } from '../objects/svg/water/svgwater53';
import { SVGWater54 } from '../objects/svg/water/svgwater54';
import { SVGWater55 } from '../objects/svg/water/svgwater55';
import { SVGWater56 } from '../objects/svg/water/svgwater56';
import { SVGWater57 } from '../objects/svg/water/svgwater57';
import { SVGWater58 } from '../objects/svg/water/svgwater58';
import { SVGWater59 } from '../objects/svg/water/svgwater59';
import { SVGWater6 } from '../objects/svg/water/svgwater6';
import { SVGWater60 } from '../objects/svg/water/svgwater60';
import { SVGWater61 } from '../objects/svg/water/svgwater61';
import { SVGWater7 } from '../objects/svg/water/svgwater7';
import { SVGWater8 } from '../objects/svg/water/svgwater8';
import { SVGWater9 } from '../objects/svg/water/svgwater9';
import { BarChartTile } from '../objects/tiles/barcharttile';
import { BarGaugeTile } from '../objects/tiles/bargaugetile';
import { ButtonTile } from '../objects/tiles/buttontile';
import { CircularProgressTile } from '../objects/tiles/circularprogresstile';
import { ClockTile } from '../objects/tiles/clocktile';
import { ColorTile } from '../objects/tiles/colortile';
import { DonutChartTile } from '../objects/tiles/donutcharttile';
import { FluidTile } from '../objects/tiles/fluidtile';
import { GaugeSparklineTile } from '../objects/tiles/gaugesparklinetile';
import { GaugeTile } from '../objects/tiles/gaugetile';
import { HighlowTile } from '../objects/tiles/highlowtile';
import { LedTile } from '../objects/tiles/ledtile';
import { NumberTile } from '../objects/tiles/numbertile';
import { PercantageTile } from '../objects/tiles/percantagetile';
import { PlusMinusTile } from '../objects/tiles/plusminustile';
import { RadialChartTile } from '../objects/tiles/radialcharttile';
import { SliderTile } from '../objects/tiles/slidertile';
import { SmoothedChartTile } from '../objects/tiles/smoothedcharttile';
import { SparklineTile } from '../objects/tiles/sparklinetile';
import { StockTile } from '../objects/tiles/stocktile';
import { SwitchTile } from '../objects/tiles/switchtile';
import { TimerControlTile } from '../objects/tiles/timercontroltile';
import { TimeTile } from '../objects/tiles/timetile';
import { TrendHistoryDB } from '../objects/trendhistorydb';
import { TrendHistoryXYDB } from '../objects/trendhistoryxydb';
import { Video } from '../objects/video';
import { WindChart } from '../objects/windchart';



export const OBJECT_REGISTRY = {
    line: Line,
    text: TextView,
    rectangle: Rectangle,
    ellipse: Ellipse,
    button: Button,
    image: ImageView,
    //group: GroupView,
    polygon: Polygon,
    polyline: Polyline,
    sector: Sector,
    border: Border,
    scale: Scale,
    textarea: TextArea,
    sphere: Sphere,
    cylinder: Cylinder,
    cylinder3d: Cylinder3D,
    cone: Cone,
    sector3d: Sector3D,
    polygongradient: PolygonGradient,
    tank: Tank,
    border3d: Border3d,
    text3d: Text3DView,
    valuewithhistory: ValueWithHistory,
    pressbutton: PressButton,
    togglebutton: ToggleButton,
    lightbutton: LightButton,
    ovallightbutton: OvalLightButton,
    imagebutton: ImageButton,
    ovaljumpbutton: OvalJumpButton,
    rectjumpbutton: RectJumpButton,
    rightjumpbutton: RightJumpButton,
    leftjumpbutton: LeftJumpButton,
    switch: Switch,
    switch3pos: Switch3Pos,
    switchapple: SwitchApple,
    ovallamp: OvalLamp,
    rectlamp: RectangleLamp,
    trilamp: TriangleLamp,
    trilamp2: TriangleLamp2,
    stacklamp: StackLamp,
    indicator: Indicator,
    rectindicator: RectIndicator,
    ovalindicator: OvalIndicator,
    slider: Slider,
    sliderver: SliderVertical,
    sliderhor: SliderHorizontal,
    sliderapple: SliderApple,
    counter: Counter,
    counterrect: CounterRect,
    selector: Selector,
    combobox: Combobox,
    menubox: Menubox,
    checkbox: Checkbox,
    menuchecklist: MenuCheckList,
    checklist: CheckList,
    parameterlist: ParameterList,
    straightpipe: StraightPipe,
    straightpipe2: StraightPipe2,
    endpipe: EndPipe,
    endpipe2: EndPipe2,
    bowpipe: BowPipe,
    bowpipe2: BowPipe2,
    teepipe: TeePipe,
    teepipe2: TeePipe2,
    intersectpipe: IntersectPipe,
    intersectpipe2: IntersectPipe2,
    elbowpipe: ElbowPipe,
    elbowpipe2: ElbowPipe2,
    polypipe: PolyPipe,
    valve: Valve,
    valveround: ValveRound,
    valveisa: ValveISA,
    valveball: ValveBall,
    valveposition: ValvePosition,
    pump: Pump,
    pumpmotor: Motor,
    airblowerpump: AirBlowerPump,
    pumpstand: PumpStand,
    fan: Fan,
    centrifugalpump: CentrifugalPump,
    fanround: FanRound,
    fansquare: FanSquare,
    fancool: FanCool,
    fanblades: FanBlades,
    fancentrifugal: FanCentrifugal,
    fanaxial: FanAxial,
    verticaltank: VerticalTank,
    horizontaltank: HorizontalTank,
    conetank: ConeTank,

    verticaltankwithtrend: VerticalTankWithTrend,
    horizontaltankwithtrend: HorizontalTankWithTrend,
    screwconveyer: ScrewConveyer,
    screwconveyermotion: ScrewConveyerMotion,
    beltconveyer: BeltConveyer,
    auger: Auger,
    analogmeter: AnalogMeter,
    analogmeterrect: AnalogMeterRect,
    analogmeter90degrees: AnalogMeter90DegreesRect,
    analogmeter90degrees2: AnalogMeter90DegreesRect2,
    analogmeterround: AnalogMeterRound,
    analogmetervertical: AnalogMeterVertical,
    analogmeterverticalfill: AnalogMeterVerticalFill,
    analogmeterhorizontal: AnalogMeterHorizontal,
    analogmeterhorizontalfill: AnalogMeterHorizontalFill,
    rangeindicator: RangeIndicator,
    gauge: Gauge,
    gauge180: Gauge180,
    gauge90: Gauge90,
    gauge902: Gauge90_2,
    digitalmeter: DigitalMeter,
    digitalmeter4: Digital4DigitMeter,
    digitalmeter6: Digital6DigitMeter,
    digitalmeter8: Digital8DigitMeter,
    digitalmeterwithhistory: DigitalMeterHistoryAndEvent,
    electricalswitch: ElectricalSwitch,
    electricalswitchtwoway: ElectricalSwitch2Way,
    electricalswitchtwowaywithneutral: ElectricalSwitchWithNeutral,
    electricaltransformer: ElectricalTransformer,
    analogclock: AnalogClock,
    digitalclock: DigitalClock,
    date: DateView,
    trend: Trend,
    eventstable: EventsTable,
    piechart: PieChart,
    eventsticker: EventsTicker,
    diagram: Diagram,
    windchart: WindChart,
    recipetable: RecipeTable,
    recipeselector: RecipeSelector,
    historydbtrend: TrendHistoryDB,
    historytable: HistoryTable,
    historyxydbtrend: TrendHistoryXYDB,
    colorpicker: ColorPicker,
    colorrect: ColorRectangle,
    video: Video,

    tanksvg: SVGTank,
    reactortank: ReactorTank,
    tanksvg2: SVGTank2,
    tanksvg3: SVGTank3,
    tanksvg4: SVGTank4,
    tanksvg5: SVGTank5,
    tanksvg6: SVGTank6,
    tanksvg7: SVGTank7,
    tanksvg8: SVGTank8,
    tanksvg9: SVGTank9,
    tanksvg10: SVGTank10,
    tanksvg11: SVGTank11,
    tanksvg12: SVGTank12,
    tanksvg13: SVGTank13,
    tanksvg14: SVGTank14,
    tanksvg15: SVGTank15,
    tanksvg16: SVGTank16,
    tanksvg17: SVGTank17,
    tanksvg18: SVGTank18,
    tanksvg19: SVGTank19,
    tanksvg20: SVGTank20,
    tanksvg21: SVGTank21,
    tanksvg22: SVGTank22,
    tanksvg23: SVGTank23,
    tanksvg24: SVGTank24,
    tanksvg25: SVGTank25,
    tanksvg26: SVGTank26,
    tanksvg27: SVGTank27,
    tanksvg28: SVGTank28,
    tanksvg29: SVGTank29,
    tanksvg30: SVGTank30,
    tanksvg32: SVGTank32,
    tanksvg33: SVGTank33,
    tanksvg34: SVGTank34,
    tanksvg35: SVGTank35,
    tanksvg36: SVGTank36,
    tanksvg37: SVGTank37,
    tanksvg38: SVGTank38,
    tanksvg39: SVGTank39,
    tanksvg40: SVGTank40,
    reactor1: Reactor1,
    reactor2: Reactor2,
    reactor4: Reactor4,
    reactor5: Reactor5,
    reactor6: Reactor6,
    reactor7: Reactor7,
    reactor8: Reactor8,
    reactor9: Reactor9,
    reactor10: Reactor10,
    tanksvg41: SVGTank41,
    tanksvg42: SVGTank42,
    tanksvg43: SVGTank43,
    tanksvg44: SVGTank44,
    tanksvg45: SVGTank45,
    tanksvg46: SVGTank46,
    tanksvg47: SVGTank47,
    tanksvg48: SVGTank48,
    tanksvg49: SVGTank49,
    tanksvg50: SVGTank50,
    tanksvg51: SVGTank51,
    tanksvg52: SVGTank52,
    tanksvg53: SVGTank53,
    tanksvg54: SVGTank54,
    tanksvg55: SVGTank55,
    tanksvg56: SVGTank56,
    tanksvg57: SVGTank57,
    tanksvg58: SVGTank58,
    tanksvg59: SVGTank59,
    tanksvg60: SVGTank60,
    tanksvg61: SVGTank61,
    tanksvg62: SVGTank62,
    tanksvg63: SVGTank63,
    tanksvg64: SVGTank64,
    tanksvg65: SVGTank65,
    tanksvg66: SVGTank66,
    tanksvg67: SVGTank67,
    tanksvg68: SVGTank68,
    tanksvg69: SVGTank69,
    tanksvg70: SVGTank70,
    tanksvg71: SVGTank71,
    tanksvg72: SVGTank72,
    valve1: SVGValve1,
    valve2: SVGValve2,
    valve3: SVGValve3,
    valve4: SVGValve4,
    valve5: SVGValve5,
    valve6: SVGValve6,
    valve7: SVGValve7,
    valve8: SVGValve8,
    valve9: SVGValve9,
    valve10: SVGValve10,
    valve11: SVGValve11,
    valve12: SVGValve12,
    valve13: SVGValve13,
    valve14: SVGValve14,
    valve15: SVGValve15,
    valve16: SVGValve16,
    valve17: SVGValve17,
    valve18: SVGValve18,
    valve19: SVGValve19,
    valve20: SVGValve20,
    valve21: SVGValve21,
    valve22: SVGValve22,
    valve23: SVGValve23,
    valve24: SVGValve24,
    valve25: SVGValve25,
    valve26: SVGValve26,
    valve27: SVGValve27,
    valve28: SVGValve28,
    valve29: SVGValve29,
    vehicle1: SVGVehicle1,
    vehicle2: SVGVehicle2,
    vehicle3: SVGVehicle3,
    vehicle4: SVGVehicle4,
    vehicle5: SVGVehicle5,
    vehicle6: SVGVehicle6,
    vehicle7: SVGVehicle7,
    vehicle8: SVGVehicle8,
    vehicle9: SVGVehicle9,
    vehicle10: SVGVehicle10,
    vehicle11: SVGVehicle11,
    vehicle12: SVGVehicle12,
    vehicle13: SVGVehicle13,
    vehicle14: SVGVehicle14,
    vehicle15: SVGVehicle15,
    vehicle16: SVGVehicle16,
    water1: SVGWater1,
    water2: SVGWater2,
    water3: SVGWater3,
    water4: SVGWater4,
    water5: SVGWater5,
    water6: SVGWater6,
    water7: SVGWater7,
    water8: SVGWater8,
    water9: SVGWater9,
    water10: SVGWater10,
    water11: SVGWater11,
    water12: SVGWater12,
    water13: SVGWater13,
    water14: SVGWater14,
    water15: SVGWater15,
    water16: SVGWater16,
    water17: SVGWater17,
    water18: SVGWater18,
    water19: SVGWater19,
    water20: SVGWater20,
    water21: SVGWater21,
    water22: SVGWater22,
    water23: SVGWater23,
    water24: SVGWater24,

    water25: SVGWater25,
    water26: SVGWater26,
    water27: SVGWater27,
    water28: SVGWater28,
    water29: SVGWater29,
    water30: SVGWater30,
    water31: SVGWater31,
    water32: SVGWater32,
    water33: SVGWater33,
    water34: SVGWater34,
    water35: SVGWater35,
    water36: SVGWater36,
    water37: SVGWater37,
    water38: SVGWater38,
    water39: SVGWater39,
    water40: SVGWater40,
    water41: SVGWater41,
    water42: SVGWater42,
    water43: SVGWater43,
    water44: SVGWater44,
    water45: SVGWater45,
    water46: SVGWater46,
    water47: SVGWater47,
    water48: SVGWater48,
    water49: SVGWater49,
    water50: SVGWater50,
    water51: SVGWater51,
    water52: SVGWater52,
    water53: SVGWater53,
    water54: SVGWater54,
    water55: SVGWater55,
    water56: SVGWater56,
    water57: SVGWater57,
    water58: SVGWater58,
    water59: SVGWater59,
    water60: SVGWater60,
    water61: SVGWater61,
    sensor1: SVGSensor1,
    sensor2: SVGSensor2,
    sensor3: SVGSensor3,
    sensor4: SVGSensor4,
    sensor5: SVGSensor5,
    sensor6: SVGSensor6,
    sensor7: SVGSensor7,
    sensor8: SVGSensor8,
    sensor9: SVGSensor9,
    sensor10: SVGSensor10,
    sensor11: SVGSensor11,
    sensor12: SVGSensor12,
    sensor13: SVGSensor13,
    sensor14: SVGSensor14,
    sensor15: SVGSensor15,
    sensor16: SVGSensor16,
    sensor17: SVGSensor17,
    sensor18: SVGSensor18,
    sensor19: SVGSensor19,
    sensor20: SVGSensor20,
    segpipe1: SVGSegpipe1,
    segpipe2: SVGSegpipe2,
    segpipe3: SVGSegpipe3,
    segpipe4: SVGSegpipe4,
    segpipe5: SVGSegpipe5,
    segpipe6: SVGSegpipe6,
    segpipe7: SVGSegpipe7,
    segpipe8: SVGSegpipe8,
    segpipe9: SVGSegpipe9,
    segpipe10: SVGSegpipe10,
    segpipe11: SVGSegpipe11,
    segpipe12: SVGSegpipe12,
    segpipe13: SVGSegpipe13,
    segpipe14: SVGSegpipe14,
    scale1: SVGScale1,
    scale2: SVGScale2,
    scale3: SVGScale3,
    scale4: SVGScale4,
    energy1: SVGEnergy1,
    energy2: SVGEnergy2,
    energy3: SVGEnergy3,
    energy4: SVGEnergy4,
    energy5: SVGEnergy5,
    energy6: SVGEnergy6,
    energy7: SVGEnergy7,
    pump1: SVGPump1,
    pump2: SVGPump2,
    pump3: SVGPump3,
    pump4: SVGPump4,
    pump5: SVGPump5,
    pump6: SVGPump6,
    pump7: SVGPump7,
    pump8: SVGPump8,
    pump9: SVGPump9,
    pump10: SVGPump10,
    pump11: SVGPump11,
    pump12: SVGPump12,
    pump13: SVGPump13,
    pump14: SVGPump14,
    pump15: SVGPump15,
    pump16: SVGPump16,
    pump17: SVGPump17,
    pump18: SVGPump18,
    pump19: SVGPump19,
    pump20: SVGPump20,
    pump21: SVGPump21,
    pump22: SVGPump22,
    pump23: SVGPump23,
    pump24: SVGPump24,
    paper1: SVGPaper1,
    paper2: SVGPaper2,
    paper3: SVGPaper3,
    paper4: SVGPaper4,
    paper5: SVGPaper5,
    paper6: SVGPaper6,
    paper7: SVGPaper7,
    paper8: SVGPaper8,
    paper9: SVGPaper9,
    paper10: SVGPaper10,
    paper11: SVGPaper11,
    paper12: SVGPaper12,
    paper13: SVGPaper13,
    paper14: SVGPaper14,
    paper15: SVGPaper15,
    paper16: SVGPaper16,
    paper17: SVGPaper17,
    paper18: SVGPaper18,
    paper19: SVGPaper19,
    heating1: SVGHeating1,
    heating2: SVGHeating2,
    heating3: SVGHeating3,
    heating4: SVGHeating4,
    heating5: SVGHeating5,
    heating6: SVGHeating6,
    heating7: SVGHeating7,
    heating8: SVGHeating8,
    heating9: SVGHeating9,
    heating10: SVGHeating10,
    heating11: SVGHeating11,
    heating12: SVGHeating12,
    heating13: SVGHeating13,
    heating14: SVGHeating14,
    heating15: SVGHeating15,
    heating16: SVGHeating16,
    heating17: SVGHeating17,
    heating18: SVGHeating18,
    heating19: SVGHeating19,
    heating20: SVGHeating20,
    heating21: SVGHeating21,
    heating22: SVGHeating22,
    heating23: SVGHeating23,
    heating24: SVGHeating24,
    heating25: SVGHeating25,
    heating26: SVGHeating26,
    cooling1: SVGCooling1,
    cooling2: SVGCooling2,
    cooling3: SVGCooling3,
    cooling4: SVGCooling4,
    cooling5: SVGCooling5,
    cooling6: SVGCooling6,
    cooling7: SVGCooling7,
    cooling8: SVGCooling8,
    cooling9: SVGCooling9,
    cooling10: SVGCooling10,
    cooling11: SVGCooling11,
    power1: SVGPower1,
    power2: SVGPower2,
    power3: SVGPower3,
    power4: SVGPower4,
    power5: SVGPower5,
    power6: SVGPower6,
    power7: SVGPower7,
    power8: SVGPower8,
    power9: SVGPower9,
    power10: SVGPower10,
    power11: SVGPower11,
    power12: SVGPower12,
    power13: SVGPower13,
    power14: SVGPower14,
    power15: SVGPower15,
    power16: SVGPower16,
    pipe1: SVGPipe1,
    pipe2: SVGPipe2,
    pipe3: SVGPipe3,
    pipe4: SVGPipe4,
    pipe5: SVGPipe5,
    pipe6: SVGPipe6,
    pipe7: SVGPipe7,
    pipe8: SVGPipe8,
    pipe9: SVGPipe9,
    pipe10: SVGPipe10,
    pipe11: SVGPipe11,
    pipe12: SVGPipe12,
    pipe13: SVGPipe13,
    pipe14: SVGPipe14,
    pipe15: SVGPipe15,
    pipe16: SVGPipe16,
    pipe17: SVGPipe17,
    pipe18: SVGPipe18,
    pipe19: SVGPipe19,
    pipe20: SVGPipe20,
    pipe21: SVGPipe21,
    pipe22: SVGPipe22,
    pipe23: SVGPipe23,
    pipe24: SVGPipe24,
    pipe25: SVGPipe25,
    pipe26: SVGPipe26,

    plant1: SVGPlant1,
    plant2: SVGPlant2,
    plant3: SVGPlant3,
    plant4: SVGPlant4,
    plant5: SVGPlant5,
    plant6: SVGPlant6,
    plant7: SVGPlant7,
    plant8: SVGPlant8,
    plant9: SVGPlant9,
    plant10: SVGPlant10,
    plant11: SVGPlant11,
    plant12: SVGPlant12,
    plant13: SVGPlant13,
    plant14: SVGPlant14,
    plant15: SVGPlant15,
    plant16: SVGPlant16,
    plant17: SVGPlant17,
    plant18: SVGPlant18,
    plant19: SVGPlant19,
    plant20: SVGPlant20,
    plant21: SVGPlant21,
    plant22: SVGPlant22,
    plant23: SVGPlant23,
    plant24: SVGPlant24,
    plant25: SVGPlant25,
    plant26: SVGPlant26,
    plant27: SVGPlant27,
    people1: SVGPeople1,
    people2: SVGPeople2,
    people3: SVGPeople3,
    people4: SVGPeople4,
    people5: SVGPeople5,
    people6: SVGPeople6,
    people7: SVGPeople7,
    people8: SVGPeople8,
    people9: SVGPeople9,
    people10: SVGPeople10,
    panel1: SVGPanel1,
    panel2: SVGPanel2,
    panel3: SVGPanel3,
    panel4: SVGPanel4,
    panel5: SVGPanel5,
    panel6: SVGPanel6,
    panel7: SVGPanel7,
    panel8: SVGPanel8,
    nuclear1: SVGNuclear1,
    nuclear2: SVGNuclear2,
    nuclear3: SVGNuclear3,
    nuclear4: SVGNuclear4,
    nuclear5: SVGNuclear5,
    nuclear6: SVGNuclear6,
    nuclear7: SVGNuclear7,
    networking1: SVGNet1,
    networking2: SVGNet2,
    networking3: SVGNet3,
    networking4: SVGNet4,
    networking5: SVGNet5,
    networking6: SVGNet6,
    networking7: SVGNet7,
    networking8: SVGNet8,
    networking9: SVGNet9,
    networking10: SVGNet10,
    networking11: SVGNet11,
    networking12: SVGNet12,
    networking13: SVGNet13,
    networking14: SVGNet14,
    networking15: SVGNet15,
    networking16: SVGNet16,
    networking17: SVGNet17,
    networking18: SVGNet18,
    networking19: SVGNet19,
    nature1: SVGNature1,
    nature2: SVGNature2,
    nature3: SVGNature3,
    nature4: SVGNature4,
    nature5: SVGNature5,
    nature6: SVGNature6,
    nature7: SVGNature7,
    nature8: SVGNature8,
    nature9: SVGNature9,
    nature10: SVGNature10,
    nature11: SVGNature11,
    nature12: SVGNature12,
    nature13: SVGNature13,
    nature14: SVGNature14,
    nature15: SVGNature15,
    interface1: SVGInterface1,
    interface2: SVGInterface2,
    interface3: SVGInterface3,
    interface4: SVGInterface4,
    interface5: SVGInterface5,
    interface6: SVGInterface6,
    interface7: SVGInterface7,
    interface8: SVGInterface8,
    interface9: SVGInterface9,
    interface10: SVGInterface10,
    interface11: SVGInterface11,
    interface12: SVGInterface12,
    interface13: SVGInterface13,
    motor1: SVGMotor1,
    motor2: SVGMotor2,
    motor3: SVGMotor3,
    motor4: SVGMotor4,
    motor5: SVGMotor5,
    motor6: SVGMotor6,
    motor7: SVGMotor7,
    motor8: SVGMotor8,
    motor9: SVGMotor9,
    motor10: SVGMotor10,
    motor11: SVGMotor11,
    motor12: SVGMotor12,
    motor13: SVGMotor13,
    motor14: SVGMotor14,
    motor15: SVGMotor15,
    motor16: SVGMotor16,
    mixer1: SVGMixer1,
    mixer2: SVGMixer2,
    mixer3: SVGMixer3,
    mixer4: SVGMixer4,
    mixer5: SVGMixer5,
    mixer6: SVGMixer6,
    mixer7: SVGMixer7,
    mixer8: SVGMixer8,
    mixer9: SVGMixer9,
    mixer10: SVGMixer10,
    mixer11: SVGMixer11,
    miscpipe1: SVGMiscpipe1,
    miscpipe2: SVGMiscpipe2,
    miscpipe3: SVGMiscpipe3,
    miscpipe4: SVGMiscpipe4,
    miscpipe5: SVGMiscpipe5,
    miscpipe6: SVGMiscpipe6,
    miscpipe7: SVGMiscpipe7,
    miscpipe8: SVGMiscpipe8,
    miscpipe9: SVGMiscpipe9,
    miscpipe10: SVGMiscpipe10,
    miscpipe11: SVGMiscpipe11,
    miscpipe12: SVGMiscpipe12,
    mining1: SVGMining1,
    mining2: SVGMining2,
    mining3: SVGMining3,
    mining4: SVGMining4,
    mining5: SVGMining5,
    mining6: SVGMining6,
    mining7: SVGMining7,
    mining8: SVGMining8,
    mining9: SVGMining9,
    mining10: SVGMining10,
    mining11: SVGMining11,
    mining12: SVGMining12,
    mining13: SVGMining13,
    mining14: SVGMining14,
    mining15: SVGMining15,
    mining16: SVGMining16,
    mining17: SVGMining17,
    mining18: SVGMining18,
    mining19: SVGMining19,
    mining20: SVGMining20,
    mining21: SVGMining21,
    mining22: SVGMining22,
    mining23: SVGMining23,
    mining24: SVGMining24,
    mining25: SVGMining25,
    mining26: SVGMining26,
    mining27: SVGMining27,
    mining28: SVGMining28,
    mining29: SVGMining29,
    mining30: SVGMining30,
    mining31: SVGMining31,
    mining32: SVGMining32,
    mining33: SVGMining33,
    medical1: SVGMedical1,
    medical2: SVGMedical2,
    medical3: SVGMedical3,
    medical4: SVGMedical4,
    medical5: SVGMedical5,
    medical6: SVGMedical6,
    medical7: SVGMedical7,
    medical8: SVGMedical8,
    medical9: SVGMedical9,
    medical10: SVGMedical10,
    medical11: SVGMedical11,
    medical12: SVGMedical12,
    medical13: SVGMedical13,
    material1: SVGMaterial1,
    material2: SVGMaterial2,
    material3: SVGMaterial3,
    material4: SVGMaterial4,
    material5: SVGMaterial5,
    material6: SVGMaterial6,
    material7: SVGMaterial7,
    material8: SVGMaterial8,
    material9: SVGMaterial9,
    material10: SVGMaterial10,
    material11: SVGMaterial11,
    material12: SVGMaterial12,
    material13: SVGMaterial13,
    material14: SVGMaterial14,
    material15: SVGMaterial15,
    material16: SVGMaterial16,
    material17: SVGMaterial17,
    material18: SVGMaterial18,
    material19: SVGMaterial19,
    material20: SVGMaterial20,
    material21: SVGMaterial21,
    material22: SVGMaterial22,
    material23: SVGMaterial23,
    material24: SVGMaterial24,
    material25: SVGMaterial25,
    material26: SVGMaterial26,
    material27: SVGMaterial27,
    material28: SVGMaterial28,
    material29: SVGMaterial29,
    material30: SVGMaterial30,
    material31: SVGMaterial31,
    material32: SVGMaterial32,
    material33: SVGMaterial33,
    machine1: SVGMachine1,
    machine2: SVGMachine2,
    machine3: SVGMachine3,
    machine4: SVGMachine4,
    machine5: SVGMachine5,
    machine6: SVGMachine6,
    machine7: SVGMachine7,
    machine8: SVGMachine8,
    machine9: SVGMachine9,
    machine10: SVGMachine10,
    machine11: SVGMachine11,
    machine12: SVGMachine12,
    machine13: SVGMachine13,
    machine14: SVGMachine14,
    machine15: SVGMachine15,
    machine16: SVGMachine16,
    machine17: SVGMachine17,
    machine18: SVGMachine18,
    machine19: SVGMachine19,
    machine20: SVGMachine20,
    machine21: SVGMachine21,
    machine22: SVGMachine22,
    machine23: SVGMachine23,
    machine24: SVGMachine24,
    machine25: SVGMachine25,
    machine26: SVGMachine26,
    machine27: SVGMachine27,
    machine28: SVGMachine28,
    machine29: SVGMachine29,
    machine30: SVGMachine30,
    machine31: SVGMachine31,
    machine32: SVGMachine32,
    machine33: SVGMachine33,
    machine34: SVGMachine34,
    logistic1: SVGLogistic1,
    logistic2: SVGLogistic2,
    logistic3: SVGLogistic3,
    logistic4: SVGLogistic4,
    logistic5: SVGLogistic5,
    logistic6: SVGLogistic6,
    logistic7: SVGLogistic7,
    logistic8: SVGLogistic8,
    logistic9: SVGLogistic9,
    logistic10: SVGLogistic10,
    logistic11: SVGLogistic11,
    symbol1: SVGSymbol1,
    symbol2: SVGSymbol2,
    symbol3: SVGSymbol3,
    symbol4: SVGSymbol4,
    symbol5: SVGSymbol5,
    symbol6: SVGSymbol6,
    symbol7: SVGSymbol7,
    symbol8: SVGSymbol8,
    symbol9: SVGSymbol9,
    symbol10: SVGSymbol10,
    symbol11: SVGSymbol11,
    symbol12: SVGSymbol12,
    symbol13: SVGSymbol13,
    symbol14: SVGSymbol14,
    hvac1: SVGHvac1,
    hvac2: SVGHvac2,
    hvac3: SVGHvac3,
    hvac4: SVGHvac4,
    hvac5: SVGHvac5,
    hvac6: SVGHvac6,
    hvac7: SVGHvac7,
    hvac8: SVGHvac8,
    hvac9: SVGHvac9,
    hvac10: SVGHvac10,
    hvac11: SVGHvac11,
    hvac12: SVGHvac12,
    hvac13: SVGHvac13,
    hvac14: SVGHvac14,
    hvac15: SVGHvac15,
    hvac16: SVGHvac16,
    hvac17: SVGHvac17,
    hvac18: SVGHvac18,
    hvac19: SVGHvac19,
    hvac21: SVGHvac21,
    hvac22: SVGHvac22,
    hvac23: SVGHvac23,
    hvac24: SVGHvac24,
    hvac25: SVGHvac25,
    hvac26: SVGHvac26,
    hvac27: SVGHvac27,
    hvac28: SVGHvac28,
    hvac29: SVGHvac29,
    hvac30: SVGHvac30,
    food1: SVGFood1,
    food2: SVGFood2,
    food3: SVGFood3,
    food4: SVGFood4,
    food5: SVGFood5,
    food6: SVGFood6,
    food7: SVGFood7,
    food8: SVGFood8,
    food9: SVGFood9,
    food10: SVGFood10,
    food11: SVGFood11,
    food12: SVGFood12,
    food13: SVGFood13,
    food14: SVGFood14,
    food15: SVGFood15,
    food16: SVGFood16,
    food17: SVGFood17,
    food18: SVGFood18,
    food19: SVGFood19,
    food20: SVGFood20,
    food21: SVGFood21,
    food22: SVGFood22,
    food23: SVGFood23,
    food24: SVGFood24,
    food25: SVGFood25,
    food26: SVGFood26,
    food27: SVGFood27,
    food28: SVGFood28,
    flex1: SVGFlex1,
    flex2: SVGFlex2,
    flex3: SVGFlex3,
    flex4: SVGFlex4,
    flex5: SVGFlex5,
    flex6: SVGFlex6,
    flex7: SVGFlex7,
    flex8: SVGFlex8,
    flex9: SVGFlex9,
    flex10: SVGFlex10,
    flow1: SVGFlow1,
    flow2: SVGFlow2,
    flow3: SVGFlow3,
    flow4: SVGFlow4,
    flow5: SVGFlow5,
    flow6: SVGFlow6,
    flow7: SVGFlow7,
    flow8: SVGFlow8,
    flow9: SVGFlow9,
    flow10: SVGFlow10,
    flow11: SVGFlow11,
    flow12: SVGFlow12,
    flow13: SVGFlow13,
    flow14: SVGFlow14,
    finish1: SVGFinish1,
    finish2: SVGFinish2,
    finish3: SVGFinish3,
    finish4: SVGFinish4,
    finish5: SVGFinish5,
    finish6: SVGFinish6,
    finish7: SVGFinish7,
    finish8: SVGFinish8,
    finish9: SVGFinish9,
    finish10: SVGFinish10,
    finish11: SVGFinish11,
    finish12: SVGFinish12,
    finish13: SVGFinish13,
    finish14: SVGFinish14,
    finish15: SVGFinish15,
    finish16: SVGFinish16,
    finish17: SVGFinish17,
    finish18: SVGFinish18,
    finish19: SVGFinish19,
    finish20: SVGFinish20,
    finish21: SVGFinish21,
    finish22: SVGFinish22,
    finish23: SVGFinish23,
    finish24: SVGFinish24,
    finish25: SVGFinish25,
    finish26: SVGFinish26,
    finish27: SVGFinish27,
    finish28: SVGFinish28,
    duct1: SVGDuct1,
    duct2: SVGDuct2,
    duct3: SVGDuct3,
    duct4: SVGDuct4,
    duct5: SVGDuct5,
    duct6: SVGDuct6,
    duct7: SVGDuct7,
    duct8: SVGDuct8,
    duct9: SVGDuct9,
    duct10: SVGDuct10,
    duct11: SVGDuct11,
    duct12: SVGDuct12,
    duct13: SVGDuct13,
    duct14: SVGDuct14,
    duct15: SVGDuct15,
    duct16: SVGDuct16,
    duct17: SVGDuct17,
    duct18: SVGDuct18,
    duct19: SVGDuct19,
    duct20: SVGDuct20,
    duct21: SVGDuct21,
    duct22: SVGDuct22,
    duct23: SVGDuct23,
    duct24: SVGDuct24,
    duct25: SVGDuct25,
    conveyor1: SVGConveyor1,
    conveyor2: SVGConveyor2,
    conveyor3: SVGConveyor3,
    conveyor4: SVGConveyor4,
    conveyor5: SVGConveyor5,
    conveyor6: SVGConveyor6,
    conveyor7: SVGConveyor7,
    conveyor8: SVGConveyor8,
    conveyor9: SVGConveyor9,
    conveyor10: SVGConveyor10,
    conveyor11: SVGConveyor11,
    controller1: SVGController1,
    controller2: SVGController2,
    controller3: SVGController3,
    controller4: SVGController4,
    controller5: SVGController5,
    controller6: SVGController6,
    controller7: SVGController7,
    controller8: SVGController8,
    controller9: SVGController9,
    controller10: SVGController10,
    controller11: SVGController11,
    container1: SVGContainer1,
    container2: SVGContainer2,
    container3: SVGContainer3,
    container4: SVGContainer4,
    container5: SVGContainer5,
    container6: SVGContainer6,
    container7: SVGContainer7,
    container8: SVGContainer8,
    container9: SVGContainer9,
    container10: SVGContainer10,
    container11: SVGContainer11,
    chemical1: SVGChemical1,
    chemical2: SVGChemical2,
    chemical3: SVGChemical3,
    chemical4: SVGChemical4,
    chemical5: SVGChemical5,
    chemical6: SVGChemical6,
    chemical7: SVGChemical7,
    chemical8: SVGChemical8,
    chemical9: SVGChemical9,
    chemical10: SVGChemical10,
    chemical11: SVGChemical11,
    chemical12: SVGChemical12,
    chemical13: SVGChemical13,
    chemical14: SVGChemical14,
    chemical15: SVGChemical15,
    factory1: SVGFactory1,
    factory2: SVGFactory2,
    factory3: SVGFactory3,
    factory4: SVGFactory4,
    factory5: SVGFactory5,
    factory6: SVGFactory6,
    factory7: SVGFactory7,
    factory8: SVGFactory8,
    factory9: SVGFactory9,
    factory10: SVGFactory10,
    factory11: SVGFactory11,
    factory12: SVGFactory12,
    factory13: SVGFactory13,
    factory14: SVGFactory14,
    factory15: SVGFactory15,
    factory16: SVGFactory16,
    factory17: SVGFactory17,
    boiler1: SVGBoiler1,
    boiler2: SVGBoiler2,
    boiler3: SVGBoiler3,
    boiler4: SVGBoiler4,
    boiler5: SVGBoiler5,
    boiler6: SVGBoiler6,
    boiler7: SVGBoiler7,
    boiler8: SVGBoiler8,
    boiler9: SVGBoiler9,
    boiler10: SVGBoiler10,
    boiler11: SVGBoiler11,
    boiler12: SVGBoiler12,
    blower1: SVGBlower1,
    blower2: SVGBlower2,
    blower3: SVGBlower3,
    blower4: SVGBlower4,
    blower5: SVGBlower5,
    blower6: SVGBlower6,
    blower7: SVGBlower7,
    blower8: SVGBlower8,
    blower9: SVGBlower9,
    blower10: SVGBlower10,
    blower11: SVGBlower11,
    blower12: SVGBlower12,
    blower13: SVGBlower13,
    button1: SVGButton1,
    button2: SVGButton2,
    button3: SVGButton3,
    button4: SVGButton4,
    button5: SVGButton5,
    button6: SVGButton6,
    button7: SVGButton7,
    button8: SVGButton8,
    button9: SVGButton9,
    button10: SVGButton10,
    button11: SVGButton11,
    button12: SVGButton12,
    button13: SVGButton13,
    button14: SVGButton14,
    button15: SVGButton15,
    button16: SVGButton16,
    button17: SVGButton17,
    button18: SVGButton18,
    button19: SVGButton19,
    architecture1: SVGArchitecture1,
    architecture2: SVGArchitecture2,
    architecture3: SVGArchitecture3,
    architecture4: SVGArchitecture4,
    architecture5: SVGArchitecture5,
    architecture6: SVGArchitecture6,
    architecture7: SVGArchitecture7,
    architecture8: SVGArchitecture8,
    architecture9: SVGArchitecture9,
    architecture10: SVGArchitecture10,
    architecture11: SVGArchitecture11,
    architecture12: SVGArchitecture12,
    architecture13: SVGArchitecture13,
    architecture14: SVGArchitecture14,
    architecture15: SVGArchitecture15,
    architecture16: SVGArchitecture16,
    architecture17: SVGArchitecture17,
    architecture18: SVGArchitecture18,
    architecture19: SVGArchitecture19,
    architecture20: SVGArchitecture20,
    architecture21: SVGArchitecture21,
    databasetable: DatabaseTable,
    percantagetile: PercantageTile,
    clocktile: ClockTile,
    gaugetile: GaugeTile,
    sparklinetile: SparklineTile,
    smoothedcharttile: SmoothedChartTile,
    timercontroltile: TimerControlTile,
    numbertile: NumberTile,
    highlowtile: HighlowTile,
    plusminustile: PlusMinusTile,
    slidertile: SliderTile,
    switchtile: SwitchTile,
    buttontile: ButtonTile,
    timetile: TimeTile,
    barcharttile: BarChartTile,
    radialcharttile: RadialChartTile,
    donutcharttile: DonutChartTile,
    circulartile: CircularProgressTile,
    stocktile: StockTile,
    gaugesparklinetile: GaugeSparklineTile,
    bargaugetile: BarGaugeTile,
    ledtile: LedTile,
    colortile: ColorTile,
    fluidtile: FluidTile,
    datechooser: DateChooser,
    gauge2: Gauge2,
    gauge3: Gauge3,
    edit: EditView,

};

export type ObjectType = keyof typeof OBJECT_REGISTRY;